import React, { Component } from 'react';
import {
    XAxis, YAxis, Tooltip, CartesianGrid,Area,AreaChart,
    Line, LineChart, ComposedChart, ResponsiveContainer, Bar,ReferenceLine, Label,
    BarChart, ScatterChart, Scatter
} from 'recharts';
import Hammer from 'hammerjs';
import moment from 'moment';
import morningWhite from '../../asset/am_white.svg';
import nightWhite from '../../asset/night_white.svg';
import bpmWhite from '../../asset/bpm_white.svg';
import iconFace1 from '../../asset/face1.svg';
import iconFace2 from '../../asset/face2.svg';
import iconFace3 from '../../asset/face3.svg';
import iconFace4 from '../../asset/face4.svg';
import iconFace5 from '../../asset/face5.svg';
import iconCondition1 from '../../asset/condition1.svg';
import iconCondition2 from '../../asset/condition2.svg';
import iconCondition3 from '../../asset/condition3.svg';
import iconCondition4 from '../../asset/condition4.svg';
import iconCondition5 from '../../asset/condition5.svg';
import iconCondition6 from '../../asset/condition6.svg';
import iconMemo from '../../asset/memo.svg';
import iconWhiteRunningMan from '../../asset/white_running_man.svg';
import iconUpArrow from '../../asset/up_arrow.svg';
import iconDownArrow from '../../asset/down_arrow.svg';
import numeral from 'numeral';
import GraphService from '../../api/graphService';
import FakeData from './data/FakeData';
import qs from 'qs';
import { stringify } from 'querystring';
import { CLIENT_RENEG_LIMIT } from 'tls';
const axios = require('axios');



// let testData = GraphService.test('2018-10-11 00:00:00','2019-10-11 23:59:59').then(function (response){
//         console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
//         console.log(response);
//         console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
//     }).catch(function (err){
//         console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
//         console.log(err);
//         console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
//     });

// GraphService.getMeasureDataEverydayTest('2019-01-01 00:00:00','2019-01-22 23:59:59').then(function (response){
//     console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
//     console.log(response);
//     console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
// }).catch(function (err){
//     console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
//     console.log(err);
//     console.log("bbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbbb")
// });

// var instance = axios.create({
//     async:true,
//     crossDomain:true,
//     headers: {
//         'X-app': "6ARYHPgi83xa5b66qLxX",
//         'X-authorization':"1c22bb68999be3b7cf2a8fb6b18440ea",
//         'Content-Type':"application/x-www-form-urlencoded"
//     },
// });

// let postData = {
//     from_date: '2019-01-01 00:00:00',
//     to_date: '2019-01-22 23:59:59'
// };

// postData = qs.stringify(postData);

// instance.post(process.env.REACT_APP_API_CONNECT_SERVICE_BASE_URL + "user/getMeasureDataEveryday", postData)
//   .then(function (response) {
//     console.group("testSuccessful");
//     console.log(response);
//     console.groupEnd();
//   })
//   .catch(function (error) {
//     console.log("===============err================")
//     console.log(error);
//     console.log("===============err================")
// });

// instance.get('http://192.168.0.110/omron-ChatService/public/index.php/user/doctorDialogsList?doctorId=1111111111111111')
//   .then(function (response) {
//     console.log(response);
//   })
//   .catch(function (error) {
//     console.log("===============err================")
//     console.log(error);
//     console.log("===============err================")
// });


const greenColor = "#00989E";
const iconFaces = [iconFace1, iconFace2, iconFace3, iconFace4, iconFace5];
const iconConditions = [iconCondition1, iconCondition2, iconCondition3, iconCondition4, iconCondition5, iconCondition6];

class RenderBPYAxisTick extends React.Component {
    formatBp(tickItem)
    {
        return numeral(tickItem).format('0.0');
    }
    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;
        value = this.formatBp(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{fontSize:'11px'}}>{value}</text>
            </g>
        )
    }
};

class RenderTEMPYAxisTick  extends  React.Component {
    formatTemp(tickItem)
    {
        return numeral(tickItem).format('0.0');
    }
    render() {
        const { x, y, payload} = this.props;
        let value = payload.value;
        value = this.formatTemp(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{ fontSize: '11px' }}>{value}</text>
            </g>
        )
    }
};

class RenderSPO2YAxisTick extends React.Component {
    formatSpo2(tickItem)
    {
        return numeral(tickItem).format('0.0');
    }
    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;
        value = this.formatSpo2(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{ fontSize: '11px' }}>{value}</text>
            </g>
        )
    }
};

class RenderBGYAxisTick extends React.Component {
    formatBG(tickItem)
    {
        return numeral(tickItem).format('0.0');
    }
    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;
        value = this.formatBG(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{ fontSize: '11px' }}>{value}</text>
            </g>
        )
    }
};

class RenderStepYAxisTick extends React.Component {
    formatStep(tickItem)
    {
        return numeral(tickItem).format('0');
    }
    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;

        value = this.formatStep(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{fontSize:'11px'}}>{value}</text>
            </g>
        )
    }
};

class RenderWeightYAxisTick extends React.Component {
    formatWeight(tickItem)
    {
        return numeral(tickItem).format('0.0');
    }

    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;

        value = this.formatWeight(value);

        return (
            <g key={x}>
                <text x={x} y={y} dy={5} textAnchor="end" style={{fontSize:'11px'}}>{value}</text>
            </g>
        )
    }
};


class RenderSleepYAxisTick extends React.Component {

    formatDateScale(minute){
        let scale = null;
        if( minute > 720 ){
            scale =  (minute / 60  - 12) + ' am';
        }else {
            scale = minute / 60 + ' pm';
        }
        return scale;
    }

    render() {
        const { x, y, payload } = this.props;
        let value = payload.value;
        value = this.formatDateScale(value);
        return (
            <g>
                <text x={x} y={y} dy={5} textAnchor="end" style={{fontSize:'11px'}}>{value}</text>
            </g>
        )
    }
};

class RenderMCXAxisTick extends React.Component {
    render() {
        const {x, y } = this.props;

        let icon;

        if
        (
            (this.props.yAxis.dataKey === "ammc" && this.props.ammc === null)
            ||
            (this.props.yAxis.dataKey === "nnmc" && this.props.nnmc === null)
            ||
            (this.props.yAxis.dataKey === "pmmc" && this.props.pmmc === null)
        )
        {
            icon = (
                <svg x={x} y={y + 7} width="20px" height="100%" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/30px/pill-inactive" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Group" fillRule="nonzero">
                            <path d="M28.0242353,1.97617182 L28.0236636,1.9756001 C23.056466,-2.98976827 17.6650442,2.96981721 17.6650442,2.96981721 L10.2857143,10.3484061 L14.9676181,15.0307742 L14.9681899,15.0313459 L19.6506654,19.7142857 L27.0305671,12.3345534 C27.0305671,12.3345534 32.9897176,6.94325535 28.0242353,1.97617182 Z" id="Shape" fill="#CCCCCC"></path>
                            <path d="M10.3490315,11.699869 L3.64065886,18.4064783 C3.57000867,18.4704096 3.42965442,18.6086491 3.24305703,18.8123473 C2.92561463,19.1588818 2.60712336,19.5541432 2.31079895,19.9882998 C0.822052436,22.169521 0.479354581,24.338299 1.87571428,26.3583844 C2.09906349,26.6814992 2.36721974,27.0010507 2.6825289,27.3164243 L2.68310064,27.3169961 L2.6835049,27.317972 C3.85159443,28.4858718 5.05793597,29 6.32066729,29 C7.54631951,29 8.80408629,28.513558 10.0119407,27.689245 C10.4461321,27.3929265 10.8414407,27.0744411 11.1880291,26.7570038 C11.3917611,26.5704075 11.5300298,26.430052 11.6282911,26.3233348 L18.3000971,19.6517006 L14.3251962,15.6764166 L14.3245813,15.6758017 L10.3490315,11.699869 Z" id="Shape" stroke="#CCCCCC" strokeWidth="2"></path>
                        </g>
                    </g>
                </svg>
            )
        }else{
            icon = (
                <svg x={x} y={y} width="20" height='100%' viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-734.000000, -226.000000)">
                            <g id="icon/30px/pill-active" transform="translate(734.000000, 226.000000)">
                                <g id="Group">
                                    <path d="M28.0242353,1.97617182 L28.0236636,1.9756001 C23.056466,-2.98976827 17.6650442,2.96981721 17.6650442,2.96981721 L10.2857143,10.3484061 L14.9676181,15.0307742 L14.9681899,15.0313459 L19.6506654,19.7142857 L27.0305671,12.3345534 C27.0305671,12.3345534 32.9897176,6.94325535 28.0242353,1.97617182 Z" id="Shape" fill="#00989E" fillRule="nonzero"></path>
                                    <path d="M18.3000971,19.6517006 L14.325153,15.6763735 L10.3491154,11.6999528 L3.67678752,18.3721088 L3.64065886,18.4064783 C3.57000867,18.4704096 3.42965442,18.6086491 3.24305703,18.8123473 C2.92561463,19.1588818 2.60712336,19.5541432 2.31079895,19.9882998 C0.822052436,22.169521 0.479354581,24.338299 1.87571428,26.3583844 C2.09906349,26.6814992 2.36721974,27.0010507 2.68266718,27.3165627 C3.85129426,28.4856168 5.05765244,29 6.32066729,29 C7.54631951,29 8.80408629,28.513558 10.0119407,27.689245 C10.4461321,27.3929265 10.8414407,27.0744411 11.1880291,26.7570038 C11.3917611,26.5704075 11.5300298,26.430052 11.6282911,26.3233348 L18.3000971,19.6517006 Z" id="Shape" stroke="#00989E" strokeWidth="2" fillRule="nonzero"></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g>
                {icon}
            </g>
        )
    }
}

class RenderMCPeriodIcon extends React.Component {

    getIcon () {
        const {external } = this.props;
        let icon;
        // console.log(this.props);

        switch(external) {
          case 'morning':
            icon = (
                <svg x={20} y={3} width="20px" height="100%" viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/30px/am-grey" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="icon" fill="#CCCCCC">
                            <path d="M5.75133333,7.57966667 C6.00366667,7.832 6.33466667,7.95833333 6.66566667,7.95833333 C6.99666667,7.95833333 7.32733333,7.832 7.58,7.57966667 C8.085,7.075 8.085,6.256 7.58,5.75133333 L6.222,4.39333333 C5.717,3.88833333 4.89866667,3.88833333 4.39366667,4.39333333 C3.88866667,4.898 3.88866667,5.717 4.39366667,6.22166667 L5.75133333,7.57966667 Z" id="Path"></path>
                            <path d="M24.6923333,25.9853333 C25.0233333,25.9853333 25.354,25.859 25.6066667,25.6066667 C26.1116667,25.102 26.1116667,24.283 25.6066667,23.7783333 L24.2486667,22.4203333 C23.7436667,21.9153333 22.9253333,21.9153333 22.4203333,22.4203333 C21.9153333,22.925 21.9153333,23.744 22.4203333,24.2486667 L23.7783333,25.6066667 C24.0306667,25.859 24.3613333,25.9853333 24.6923333,25.9853333 Z" id="Path"></path>
                            <path d="M6.222,25.6063333 L7.58,24.2483333 C8.085,23.7436667 8.085,22.9246667 7.58,22.42 C7.075,21.915 6.25666667,21.915 5.75166667,22.42 L4.39366667,23.778 C3.88866667,24.2826667 3.88866667,25.1016667 4.39366667,25.6063333 C4.646,25.8586667 4.977,25.985 5.308,25.985 C5.63866667,25.9853333 5.96933333,25.859 6.222,25.6063333 Z" id="Path"></path>
                            <path d="M23.3343333,7.95866667 C23.6653333,7.95866667 23.996,7.83233333 24.2486667,7.58 L25.6066667,6.222 C26.1116667,5.71733333 26.1116667,4.89833333 25.6066667,4.39366667 C25.1016667,3.88866667 24.2833333,3.88866667 23.7783333,4.39366667 L22.4203333,5.75166667 C21.9153333,6.25633333 21.9153333,7.07533333 22.4203333,7.58 C22.6726667,7.83233333 23.0036667,7.95866667 23.3343333,7.95866667 Z" id="Path"></path>
                            <path d="M1.293,16.293 L3.21333333,16.293 C3.92733333,16.293 4.50633333,15.714 4.50633333,15 C4.50633333,14.286 3.92733333,13.707 3.21333333,13.707 L1.293,13.707 C0.579,13.707 0,14.286 0,15 C0,15.714 0.579,16.293 1.293,16.293 Z" id="Path"></path>
                            <path d="M25.4936667,15 C25.4936667,15.714 26.0726667,16.293 26.7866667,16.293 L28.707,16.293 C29.421,16.293 30,15.714 30,15 C30,14.286 29.421,13.707 28.707,13.707 L26.7866667,13.707 C26.0726667,13.707 25.4936667,14.286 25.4936667,15 Z" id="Path"></path>
                            <path d="M15,25.4936667 C14.286,25.4936667 13.707,26.0726667 13.707,26.7866667 L13.707,28.707 C13.707,29.421 14.286,30 15,30 C15.714,30 16.293,29.421 16.293,28.707 L16.293,26.7866667 C16.293,26.0726667 15.714,25.4936667 15,25.4936667 Z" id="Path"></path>
                            <path d="M15,4.50633333 C15.714,4.50633333 16.293,3.92733333 16.293,3.21333333 L16.293,1.293 C16.293,0.579 15.714,0 15,0 C14.286,0 13.707,0.579 13.707,1.293 L13.707,3.21333333 C13.707,3.92733333 14.286,4.50633333 15,4.50633333 Z" id="Path"></path>
                            <path d="M15,23.6566667 C19.7733333,23.6566667 23.6566667,19.7733333 23.6566667,15 C23.6566667,10.2266667 19.7733333,6.34333333 15,6.34333333 C10.2266667,6.34333333 6.34333333,10.2266667 6.34333333,15 C6.34333333,19.7733333 10.2266667,23.6566667 15,23.6566667 Z M15,8.92933333 C18.3473333,8.92933333 21.0706667,11.6523333 21.0706667,15 C21.0706667,18.3476667 18.3473333,21.0706667 15,21.0706667 C11.6526667,21.0706667 8.92933333,18.3473333 8.92933333,15 C8.92933333,11.6526667 11.6526667,8.92933333 15,8.92933333 Z" id="Shape" fillRule="nonzero"></path>
                        </g>
                    </g>
                </svg>
            );
            break;
          case 'noon':
            icon = (
                <svg x={20} y={3} width="20" height='100%' viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/30px/noon-gray" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="icon/30px/noon2-gray" transform="translate(1.000000, 1.000000)" fill="#CCCCCC" stroke="#CCCCCC">
                            <g id="Group" transform="translate(0.933333, 0.933333)">
                                <path d="M13.5333333,7.21777778 C10.051357,7.21777778 7.21777778,10.0506553 7.21777778,13.5333333 C7.21777778,17.0160114 10.051357,19.8488889 13.5333333,19.8488889 C17.0153096,19.8488889 19.8488889,17.0160114 19.8488889,13.5333333 C19.8488889,10.0506553 17.0153096,7.21777778 13.5333333,7.21777778 Z M13.5333333,18.4454321 C10.8246617,18.4454321 8.62123457,16.2413032 8.62123457,13.5333333 C8.62123457,10.8253635 10.8246617,8.62123457 13.5333333,8.62123457 C16.2420049,8.62123457 18.4454321,10.8253635 18.4454321,13.5333333 C18.4454321,16.2413032 16.2420049,18.4454321 13.5333333,18.4454321 Z" id="Shape" strokeWidth="0.801975309" fillRule="nonzero"></path>
                                <path d="M13.5333333,4.22916667 C14.0002333,4.22916667 14.3791667,3.85107917 14.3791667,3.38333333 L14.3791667,0.845833333 C14.3791667,0.3780875 14.0002333,0 13.5333333,0 C13.0664333,0 12.6875,0.3780875 12.6875,0.845833333 L12.6875,3.38333333 C12.6875,3.85107917 13.0664333,4.22916667 13.5333333,4.22916667 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M13.5333333,22.8375 C13.0664333,22.8375 12.6875,23.2155875 12.6875,23.6833333 L12.6875,26.2208333 C12.6875,26.6885792 13.0664333,27.0666667 13.5333333,27.0666667 C14.0002333,27.0666667 14.3791667,26.6885792 14.3791667,26.2208333 L14.3791667,23.6833333 C14.3791667,23.2155875 14.0002333,22.8375 13.5333333,22.8375 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M7.72584167,5.16635 C7.9601375,5.57065833 8.47694167,5.709375 8.88125,5.475925 C9.28555833,5.242475 9.424275,4.724825 9.190825,4.32051667 L7.922075,2.12219583 C7.68777917,1.71873333 7.17182083,1.57917083 6.76666667,1.81346667 C6.36235833,2.04691667 6.22364167,2.56372083 6.45709167,2.968875 L7.72584167,5.16635 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M19.340825,21.9011625 C19.1065292,21.4977 18.5905708,21.3572917 18.1854167,21.5915875 C17.7811083,21.8250375 17.6423917,22.3426875 17.8758417,22.7469958 L19.1445917,24.9453167 C19.3788875,25.349625 19.8956917,25.4883417 20.3,25.2548917 C20.7043083,25.0214417 20.843025,24.5037917 20.609575,24.0994833 L19.340825,21.9011625 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M5.16635,7.72584167 L2.968875,6.45709167 C2.56202917,6.22195 2.04691667,6.3615125 1.81346667,6.76666667 C1.58001667,7.170975 1.71873333,7.688625 2.12304167,7.922075 L4.32051667,9.190825 C4.72567083,9.424275 5.24162917,9.28555833 5.475925,8.88125 C5.709375,8.47609583 5.57065833,7.95929167 5.16635,7.72584167 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M24.943625,19.1445917 L22.74615,17.8758417 C22.3409958,17.6423917 21.8241917,17.7802625 21.5907417,18.1854167 C21.3572917,18.5905708 21.4960083,19.107375 21.9003167,19.340825 L24.0977917,20.609575 C24.4961792,20.8396417 25.0172125,20.7085375 25.2532,20.3 C25.48665,19.8948458 25.3487792,19.3780417 24.943625,19.1445917 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M4.22916667,13.5333333 C4.22916667,13.0655875 3.85023333,12.6875 3.38333333,12.6875 L0.845833333,12.6875 C0.378933333,12.6875 0,13.0655875 0,13.5333333 C0,14.0010792 0.378933333,14.3791667 0.845833333,14.3791667 L3.38333333,14.3791667 C3.85023333,14.3791667 4.22916667,14.0010792 4.22916667,13.5333333 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M26.2208333,12.6875 L23.6833333,12.6875 C23.2164333,12.6875 22.8375,13.0655875 22.8375,13.5333333 C22.8375,14.0010792 23.2164333,14.3791667 23.6833333,14.3791667 L26.2208333,14.3791667 C26.6877333,14.3791667 27.0666667,14.0010792 27.0666667,13.5333333 C27.0666667,13.0655875 26.6877333,12.6875 26.2208333,12.6875 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M4.32051667,17.8758417 L2.12304167,19.1445917 C1.7178875,19.3780417 1.58001667,19.8948458 1.81346667,20.3 C2.0477625,20.7051542 2.56456667,20.8421792 2.968875,20.609575 L5.16635,19.340825 C5.57065833,19.107375 5.709375,18.589725 5.475925,18.1854167 C5.242475,17.7794167 4.72567083,17.6415458 4.32051667,17.8758417 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M22.7469958,9.190825 L24.9444708,7.922075 C25.3487792,7.688625 25.48665,7.170975 25.2532,6.76666667 C25.0189042,6.36066667 24.5004083,6.22195 24.0977917,6.45709167 L21.9003167,7.72584167 C21.4960083,7.95929167 21.3572917,8.47694167 21.5907417,8.88125 C21.827575,9.2897875 22.3477625,9.42089167 22.7469958,9.190825 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M8.88125,21.5907417 C8.47525,21.3572917 7.95929167,21.4968542 7.72584167,21.9003167 L6.45709167,24.0986375 C6.22364167,24.5037917 6.36235833,25.0205958 6.76666667,25.2540458 C7.17182083,25.4874958 7.68777917,25.3487792 7.922075,24.9444708 L9.190825,22.74615 C9.424275,22.3418417 9.28555833,21.8250375 8.88125,21.5907417 Z" id="Path" strokeWidth="0.5"></path>
                                <path d="M18.1854167,5.47677083 C18.5905708,5.71022083 19.1065292,5.57150417 19.340825,5.16719583 L20.609575,2.968875 C20.843025,2.56372083 20.7043083,2.04691667 20.3,1.81346667 C19.894,1.58001667 19.3780417,1.71957917 19.1445917,2.12304167 L17.8758417,4.3213625 C17.6423917,4.72567083 17.7811083,5.242475 18.1854167,5.47677083 Z" id="Path" strokeWidth="0.5"></path>
                            </g>
                        </g>
                    </g>
                </svg>
            );
            break;
          case 'evening':
            icon = (
                <svg x={20} y={3} width="20" height='100%' viewBox="0 0 30 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="icon/30px/night-gray" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <path d="M21.7616729,22.2134329 C15.7542426,22.2134329 10.8711974,17.3303878 10.8711974,11.3229574 C10.8711974,9.18390767 11.4824372,7.15115825 12.6111403,5.420819 C8.2058203,6.66623848 5.03079666,10.6949851 5.03079666,15.4922181 C5.03079666,21.2596918 9.7403082,25.9692033 15.5077819,25.9692033 C18.7130372,25.9692033 21.7169757,24.4813004 23.6787052,22.0418079 C23.0496747,22.1560785 22.410206,22.2134329 21.7616729,22.2134329 Z M26.8592455,20.7363662 C24.8234737,25.1499195 20.3610619,28 15.5077819,28 C8.61873017,28 3,22.3812698 3,15.4922181 C3,8.73345567 8.29300668,3.2450149 15.0354829,3.00072228 C15.4914958,2.98443611 15.8660778,3.2450149 16.0289395,3.63588308 C16.2080874,4.04303744 16.0940842,4.5153365 15.7846469,4.80848764 C13.928023,6.50224978 12.901994,8.81488655 12.901994,11.3229574 C12.901994,16.2088097 16.8758206,20.1826363 21.7616729,20.1826363 C23.0482807,20.1826363 24.28603,19.9057713 25.4749207,19.3520414 C25.882075,19.1728935 26.3380879,19.2543243 26.6475252,19.5637617 C26.9569626,19.873199 27.0383934,20.345498 26.8592455,20.7363662 Z" id="" fill="#CCCCCC" fillRule="nonzero"></path>
                    </g>
                </svg>
            );
            break;
          default:
            icon = null;
            break;
        }

        return icon;
      }

    render() {
        return (
            <g>
                {this.getIcon()}
            </g>
        )
    }
}

export default class Graph extends Component {

    constructor(props) {
        super(props);
        this.lastSelectedIndex = -1;
        this.fullData = {main:null, bpm:null, weight:null, mewc:null, step:null, sleep:null, temperature:null, bg:null, spo2:null};
        this.dataMonthDirection = null;
        this.mewcStartLabelY = 0;
        // let totalPage = this.getTotalPage(props.data);
        // let curPage = totalPage;
        // let medicationPeriod = this.props.medicationPeriod;
        // if(medicationPeriod == null)
        // {
        //     medicationPeriod = {morning:false, noon:false, evening: false};
        // }

        let today = new Date();
        let daysAgo30 = new Date().setDate(today.getDate() - 29);

        let toDate = moment(today).format('YYYY-MM-DD') + " 23:59:59";
        let fromDate = moment(daysAgo30).format('YYYY-MM-DD') + " 00:00:00";

        // console.log(today, daysAgo30, fromDate, toDate);

        this.state = {
            isLoading: false,
            fromDate: fromDate,
            toDate: toDate,
            startDate:null,
            endDate:null,
            data: null,
            dataBPM: null,
            dataWeight: null,
            dataStep: null,
            dataSleep: null,
            dataFeeling:null,
            dataTemperature:null,
            dataBG:null,
            dataSpo2:null,
            dataAverage:{step:0,weight:0,bpm:0,abpm:0,pbpm:0,sleep_h:0,sleep_m:0,bg:0,spo2:0},
            dataDiff:{step:0,weight:0,bp:0,sleep:0,feeling:0,bg:0,spo2:0},
            medicationDisplay:{morning:"none", noon:"none", evening: "none"},
            maskBar: {
                x: -9999,
                y: -9999
            },
            maskBarCircle: {
                x: -9999
            },
            maskBarPositions : [0,0,0,0,0,0,0],
            curBPData:{
                ambp:0,
                pmbp:0
            },
            tipBoxBP: {
                x:-9999,
                arrowX:-9999,
                arrowY: "0%",
            },
            tipBoxTemperature: {
                x:-9999,
                y: -9999,
                arrowX:-9999,
                arrowY: "0%",
            },
            tipBoxBG: {
                x:-9999,
                y: -9999,
                arrowX:-9999,
                arrowY: "0%",
            },
            tipBoxSpo2: {
                x:-9999,
                y: -9999,
                arrowX:-9999,
                arrowY: "0%",
            },
            tipBoxStep: {
                x:-9999,
                y:-9999,
                arrowX: -9999,
                arrowY: "0%",
            },
            tipBoxSleep:{
                x:-9999,
                y:-9999,
                arrowX: -9999,
                arrowY: "0%",
            },
            stepDotPositions : [0,0,0,0,0,0,0],
            tipBoxWeight: {
                x:-9999,
                y:-9999,
                arrowX: -9999,
                arrowY: "0%",
            },
            weightDotPositions : [0,0,0,0,0,0,0],
            tipBoxCondition: {
                x:-9999,
                y:-9999,
                arrowX: -9999,
                arrowY: "0%",
                width:"0px",
                content: (<div></div>)
            },
            conditionIconPositions : [0,0,0,0,0,0,0],
            curBPMData:{
                ambpm:0,
                pmbpm:0
            },
            curTemperatureData:{
                amTemp:0,
                pmTemp:0
            },
            temperaturePositions: [0, 0, 0, 0, 0, 0, 0],
            curBGData:{
                ambg:0,
                pmbg:0
            },
            bgPositions: [0, 0, 0, 0, 0, 0, 0],
            curSpo2Data:{
                amspo2:0,
                pmspo2:0
            },
            spo2Positions: [0, 0, 0, 0, 0, 0, 0],
            curWeightData:{
                amweight:0,
                pmweight:0
            },
            curStepData:{
                step:0,
            },
            curSleepData:{
                sleep_time:'',
                wake_up_time:'',
                duration:''
            },
            page:{
                curPage:0,
                totalPage:0,
            },
            // sysGoal:135,
            // diaGoal:85,
            sysGoal: '',
            diaGoal: '',
            temperatureGoal: 37.5,
            stepGoal:0,
            weightHGoal: '',
            weightLGoal: '',
            glucoseBeforeMealHGoal: '',
            glucoseBeforeMealLGoal: '',
            glucoseAfterMealHGoal: '',
            glucoseAfterMealLGoal: '',
            spo2HGoal:'',
            spo2LGoal: '',
            sleepTime:0,
            wakeUpTime:0,
            clickCalendar:''
        };
    }

    prePage()
    {
        let page = this.state.page.curPage;
        if(page>=2)
        {
            page--;
        }else{
            this.preMonth();
            return;
            // page = 1;
        }

        this.setState(
            {
                page:{
                    curPage:page,
                    totalPage:this.state.page.totalPage
                }
            }
        )

        this.reloadData();
    }

    nextPage()
    {
        let page = this.state.page.curPage;
        if(page<this.state.page.totalPage )
        {
            page++;
        }else{
            this.nextMonth();
            return;
            // page = this.state.page.totalPage;
        }

        this.setState(
            {
                page:{
                    curPage:page,
                    totalPage:this.state.page.totalPage
                }
            }
        )

        this.reloadData();
    }

    reloadData()
    {
        if(this.fullData==null || this.fullData.main==null) return;

        let curPage = this.state.page.curPage;
        let totalPage = this.state.page.totalPage;
        let getBf7daysData = false;

        let startIndex = this.fullData.main.length - (((totalPage - curPage) + 1) * 7);
        let bf7daysIndex = startIndex-7;
        if(bf7daysIndex < 7) {
            getBf7daysData = true;
            if(bf7daysIndex <= -7){
                this.reorganizeBf7daysData(this.fullData.main[0].day , this.fullData.main[6].day);
            }else{
                this.reorganizeBf7daysData(this.fullData.main[startIndex].day , this.fullData.main[startIndex+6].day);
            }

        }else{
            getBf7daysData = false;
        }
        if(startIndex<0) startIndex=0;

        let dataMain = [];
        let dataBPM = [];
        let dataWeight = [];
        let dataStep = [];
        let dataSleep = [];
        let dataTemperature =[]
        let dataBG =[]
        let dataSpo2 =[]
        
        let n = startIndex * 2;
        let n2 = bf7daysIndex * 2;
        let stepSum = 0;
        let bf7daysStepSum = 0;
        let weightSum = 0;
        let bf7daysWeightSum = 0;
        let bpmSum = 0;
        let bf7daysBpmSum = 0;
        
        let bgSum = 0;
        let bf7daysBgSum = 0;

        let spo2Sum = 0;
        let bf7daysSpo2Sum = 0;

        let mainSumA = 0;
        let bf7daysMainSumA = 0;
        let mainSumP = 0;
        let bf7daysMainSumP = 0;
        let feelingSum = 0;
        let bf7daysFeelingSum = 0;
        let weightCount = 0;
        let bf7daysWeightCount = 0;
        let bpmCount = 0;
        let bf7daysBpmCount = 0;
        let bgCount = 0;
        let bf7daysBgCount = 0;

        let spo2Count = 0;
        let bf7daysSpo2Count = 0;
        let mainCountP = 0;
        let bf7daysMainCountP = 0;
        let mainCountA = 0;
        let bf7daysMainCountA = 0;
        let feelingCount = 0;
        let bf7daysFeelingCount = 0;

        if(!getBf7daysData){
            for(var i=bf7daysIndex;i<this.fullData.main.length;i++)
            {
                if(i>=startIndex) break;
                if(this.fullData.weight[n2].weight != null || this.fullData.weight[n2].weight != undefined){
                    bf7daysWeightSum += parseFloat(this.fullData.weight[n2].weight);
                    bf7daysWeightCount++;
                    if(this.fullData.weight[n2+1].weight != null || this.fullData.weight[n2+1].weight != undefined){
                        bf7daysWeightSum += parseFloat(this.fullData.weight[n2+1].weight);
                        bf7daysWeightCount++
                    }
                }
                if(this.fullData.bpm[n2].bpm != null || this.fullData.bpm[n2].bpm != undefined){
                    bf7daysBpmSum += parseInt(this.fullData.bpm[n2].bpm);
                    bf7daysBpmCount++;
                    if(this.fullData.bpm[n2+1].bpm != null || this.fullData.bpm[n2+1].bpm != undefined){
                        bf7daysBpmSum += parseInt(this.fullData.bpm[n2+1].bpm);
                        bf7daysBpmCount++;
                    }
                }
                if (this.fullData.bg[n2].bg != null || this.fullData.bg[n2].bg != undefined) {
                    bf7daysBgSum += parseInt(this.fullData.bg[n2].bg);
                    bf7daysBgCount++;
                    if (this.fullData.bg[n2 + 1].bg != null || this.fullData.bg[n2 + 1].bg != undefined) {
                        bf7daysBgSum += parseInt(this.fullData.bg[n2 + 1].bg);
                        bf7daysBgCount++;
                    }
                }
                if (this.fullData.spo2[n2].spo2 != null || this.fullData.spo2[n2].spo2 != undefined) {
                    bf7daysSpo2Sum += parseInt(this.fullData.spo2[n2].spo2);
                    bf7daysSpo2Count++;
                    if (this.fullData.spo2[n2 + 1].spo2 != null || this.fullData.spo2[n2 + 1].spo2 != undefined) {
                        bf7daysSpo2Sum += parseInt(this.fullData.spo2[n2 + 1].spo2);
                        bf7daysSpo2Count++;
                    }
                }
                if(this.fullData.main[i].ambp[0] != null || this.fullData.main[i].ambp[0] != undefined){
                    bf7daysMainSumA += parseInt(this.fullData.main[i].ambp[0]);
                    bf7daysMainCountA++;
                    if(this.fullData.main[i].pmbp[0] != null || this.fullData.main[i].pmbp[0] != undefined){
                        bf7daysMainSumA += parseInt(this.fullData.main[i].pmbp[0]);
                        bf7daysMainCountA++;
                    }
                }
                if(this.fullData.main[i].ambp[1] != null || this.fullData.main[i].ambp[1] != undefined){
                    bf7daysMainSumP += parseInt(this.fullData.main[i].ambp[1]);
                    bf7daysMainCountP++;
                    if(this.fullData.main[i].pmbp[1] != null || this.fullData.main[i].pmbp[1] != undefined){
                        bf7daysMainSumP += parseInt(this.fullData.main[i].pmbp[1]);
                        bf7daysMainCountP++;
                    }
                }

                if(this.fullData.main[i].feelings.feeling != null || this.fullData.main[i].feelings.feeling != undefined){
                    bf7daysFeelingSum += parseInt(this.fullData.main[i].feelings.feeling);
                    bf7daysFeelingCount++;
                }

                n2+=2;
            }
        }

        for(var i=startIndex;i<this.fullData.main.length;i++)
        {
            if(this.fullData.weight[n].weight != null || this.fullData.weight[n].weight != undefined){
                weightSum += parseFloat(this.fullData.weight[n].weight);
                weightCount++;
                if(this.fullData.weight[n+1].weight != null || this.fullData.weight[n+1].weight != undefined){
                    weightSum += parseFloat(this.fullData.weight[n+1].weight);
                    weightCount++
                }
            }
            if(this.fullData.bpm[n].bpm != null || this.fullData.bpm[n].bpm != undefined){
                bpmSum += parseInt(this.fullData.bpm[n].bpm);
                bpmCount++;
                if(this.fullData.bpm[n+1].bpm != null || this.fullData.bpm[n+1].bpm != undefined){
                    bpmSum += parseInt(this.fullData.bpm[n+1].bpm);
                    bpmCount++;
                }
            }
            if (this.fullData.bg[n].bg != null || this.fullData.bg[n].bg != undefined) {
                bgSum += parseInt(this.fullData.bg[n].bg);
                bgCount++;
                if (this.fullData.bg[n + 1].bg != null || this.fullData.bg[n + 1].bg != undefined) {
                    bgSum += parseInt(this.fullData.bg[n + 1].bg);
                    bgCount++;
                }
            }

            if (this.fullData.spo2[n].spo2 != null || this.fullData.spo2[n].spo2 != undefined) {
                spo2Sum += parseInt(this.fullData.spo2[n].spo2);
                spo2Count++;
                if (this.fullData.spo2[n + 1].spo2 != null || this.fullData.spo2[n + 1].spo2 != undefined) {
                    spo2Sum += parseInt(this.fullData.spo2[n + 1].spo2);
                    spo2Count++;
                }
            }
            if(this.fullData.main[i].ambp[0] != null || this.fullData.main[i].ambp[0] != undefined){
                mainSumA += parseInt(this.fullData.main[i].ambp[0]);
                mainCountA++;
                if(this.fullData.main[i].pmbp[0] != null || this.fullData.main[i].pmbp[0] != undefined){
                    mainSumA += parseInt(this.fullData.main[i].pmbp[0]);
                    mainCountA++;
                }
            }
            if(this.fullData.main[i].ambp[1] != null || this.fullData.main[i].ambp[1] != undefined){
                mainSumP += parseInt(this.fullData.main[i].ambp[1]);
                mainCountP++;
                if(this.fullData.main[i].pmbp[1] != null || this.fullData.main[i].pmbp[1] != undefined){
                    mainSumP += parseInt(this.fullData.main[i].pmbp[1]);
                    mainCountP++;
                }
            }
            if(this.fullData.main[i].feelings.feeling != null || this.fullData.main[i].feelings.feeling != undefined){
                feelingSum += parseInt(this.fullData.main[i].feelings.feeling);
                feelingCount++;
            }
            
            this.fullData.weight[n].weight_am = this.fullData.weight[n].weight;
            this.fullData.weight[n+1].weight_pm = this.fullData.weight[n+1].weight;

            dataMain.push(this.fullData.main[i]);
            dataBPM.push(this.fullData.bpm[n]);
            dataWeight.push(this.fullData.weight[n]);
            dataWeight.push(this.fullData.weight[n+1]);
            dataBPM.push(this.fullData.bpm[n+1]);

            dataTemperature.push(this.fullData.temperature[n]);
            dataTemperature.push(this.fullData.temperature[n+1]);

            dataBG.push(this.fullData.bg[n]);
            dataBG.push(this.fullData.bg[n+1]);

            dataSpo2.push(this.fullData.spo2[n]);
            dataSpo2.push(this.fullData.spo2[n+1]);

            n+=2;
            if(dataMain.length>=7) break;
        }

        dataWeight = this.generateMEWCGoalData(dataWeight);

        let weight = [];
        if(dataWeight !== null){
            let pre_date = '';
            let stemp_weight = {};
            for(var i=0;i<dataWeight.length;i++){
                var _day =  dataWeight[i].day;
                _day = moment(_day).format('YYYY-MM-DD');

                if(pre_date !==  _day){
                    pre_date =  _day;
                    stemp_weight = dataWeight[i];
                }else if(pre_date == _day && i % 2 == 1){
                    stemp_weight.day = _day;
                    if(dataWeight[i].weight_pm !== undefined){
                        stemp_weight.weight_pm = dataWeight[i].weight_pm;
                    }
                    weight.push(stemp_weight);
                }
            }
        }

        let stepAvgCount = 0;
        let bf7daysStepAvgCount = 0;
        let weightAvg = 0;
        let bpmAvg = 0;
        let bgAvg = 0;
        let spo2Avg = 0;

        let stepAvg = 0;
        let mainAvgA = 0;
        let mainAvgP = 0;
        let sleepAvg = 0;
        let sleepSum = 0;
        let bf7daysSleepSum = 0;
        let sleepCount = 0;
        let bf7daysSleepCount = 0;
        let feelingAvg = 0;

        if(!getBf7daysData){
            for (var s=bf7daysIndex;s<this.fullData.step.length;s++){
                if(s >= startIndex ) break;
                if(this.fullData.step[s].step != null || this.fullData.step[s].step != undefined){
                    bf7daysStepSum += parseInt(this.fullData.step[s].step);
                    bf7daysStepAvgCount++;
                }
            }
        }

        for (var s=startIndex;s<this.fullData.step.length;s++){
            dataStep.push(this.fullData.step[s]);
            if(this.fullData.step[s].step != null || this.fullData.step[s].step != undefined){
                stepSum += parseInt(this.fullData.step[s].step);
                stepAvgCount++;
            }
            if(dataStep.length >= 7) break;
        }

        if(!getBf7daysData){
            for (var s=bf7daysIndex;s<this.fullData.sleep.length;s++){
                if(s >= startIndex ) break;
                if(this.fullData.sleep[s].duration != null || this.fullData.sleep[s].duration != undefined){
                    bf7daysSleepSum += parseInt(this.fullData.sleep[s].duration);
                    bf7daysSleepCount++;
                }
            }
        }
        for (var s=startIndex;s<this.fullData.sleep.length;s++){
            dataSleep.push(this.fullData.sleep[s]);
            if(this.fullData.sleep[s].duration != null || this.fullData.sleep[s].duration != undefined){
                sleepSum += parseInt(this.fullData.sleep[s].duration);
                sleepCount++;
            }
            if(dataSleep.length >= 7) break;
        }

        if(stepAvgCount != 0){
            stepAvg = parseInt(stepSum / stepAvgCount);
        }
        if(weightCount != 0){
            weightAvg = parseFloat(weightSum / weightCount).toFixed(1);
        }
        if(bpmCount != 0){
            bpmAvg = parseInt(bpmSum / bpmCount);
        }
        if (bgCount != 0) {
            bgAvg = parseInt(bgSum / bgCount);
        }
        if (spo2Count != 0) {
            spo2Avg = parseInt(spo2Sum / spo2Count);
        }
        if(mainCountA != 0){
            mainAvgA = parseInt(mainSumA / mainCountA);
        }
        if(mainCountP != 0){
            mainAvgP = parseInt(mainSumP / mainCountP);
        }
        if(sleepCount != 0){
            sleepAvg = parseInt(sleepSum / sleepCount);
        }
        if(feelingCount != 0){
            feelingAvg = parseInt(feelingSum / feelingCount);
        }

        if(!getBf7daysData){
            let bf7daysStepAvg = 0;
            let bf7daysWeightAvg = 0;
            let bf7daysBpmAvg = 0;
            let bf7daysBgAvg = 0;
            let bf7daysSPO2Avg = 0;
            let bf7daysMainAvgA = 0;
            let bf7daysMainAvgP = 0;
            let bf7daysSleepAvg = 0;
            let bf7daysFeelingAvg = 0;

            if(bf7daysStepAvgCount != 0){
                bf7daysStepAvg = parseInt(bf7daysStepSum / bf7daysStepAvgCount);
            }

            if(bf7daysWeightCount != 0){
                bf7daysWeightAvg = parseFloat(bf7daysWeightSum / bf7daysWeightCount).toFixed(1);
            }
            if(bf7daysBpmCount != 0){
                bf7daysBpmAvg = parseInt(bf7daysBpmSum / bf7daysBpmCount);
            }
            if (bf7daysBgCount != 0) {
                bf7daysBgAvg = parseInt(bf7daysBgSum / bf7daysBgCount);
            }
            if (bf7daysSpo2Count != 0) {
                bf7daysSPO2Avg = parseInt(bf7daysSpo2Sum / bf7daysSpo2Count);
            }
            if(bf7daysMainCountA != 0){
                bf7daysMainAvgA = parseInt(bf7daysMainSumA / bf7daysMainCountA);
            }
            if(bf7daysMainCountP != 0){
                bf7daysMainAvgP = parseInt(bf7daysMainSumP / bf7daysMainCountP);
            }
            if(bf7daysSleepCount != 0){
                bf7daysSleepAvg = parseInt(bf7daysSleepSum / bf7daysSleepCount);
            }
            if(bf7daysFeelingCount != 0){
                bf7daysFeelingAvg = parseInt( bf7daysFeelingSum / bf7daysFeelingCount);
            }

            let diffStep =  stepAvg - bf7daysStepAvg;
            let diffWeight = weightAvg - bf7daysWeightAvg ;
            let diffBpm = bpmAvg - bf7daysBpmAvg ;
            let diffBg = bgAvg - bf7daysBgAvg ;
            let diffSpo2 = spo2Avg - bf7daysSPO2Avg ;
            let diffAbpm = mainAvgA - bf7daysMainAvgA;
            let diffPbpm = mainAvgP - bf7daysMainAvgP;
            let diffSleep = sleepAvg - bf7daysSleepAvg;
            let diffFeeling = feelingAvg - bf7daysFeelingAvg ;
            this.setState({
                dataDiff:{
                    step: diffStep,
                    weight: diffWeight,
                    bpm: diffBpm,
                    bg: diffBg,
                    spo2: diffSpo2,
                    abpm: diffAbpm,
                    pbpm: diffPbpm,
                    sleep: diffSleep,
                    feeling: diffFeeling
                }
            });
        }

        this.setState(
            {
                data: dataMain,
                dataBPM: dataBPM,
                dataWeight: weight,
                dataStep: dataStep,
                dataSleep:dataSleep,
                dataTemperature:dataTemperature,
                dataBG: dataBG,
                dataSpo2: dataSpo2,
                dataAverage: {step:stepAvg,weight:weightAvg,bpm:bpmAvg,abpm:mainAvgA,pbpm:mainAvgP,sleep_h:parseInt(sleepAvg / 60),sleep_m:parseInt(sleepAvg % 60),bg: bgAvg, spo2: spo2Avg},
            }
        )
        this.hideTips();
    }

    getTotalPage(data)
    {
        if(data==null || data.length==0)
        {
            return -1;
        }

        return parseInt(data.length / 7) + 1;
    }

    renderLabelContent = (props) => {
        const { value } = props;

        const x = props.viewBox.x;
        const y = props.viewBox.y;

        var offsetRectX = -28;
        let offsetRectWidth = 28;
        let val = value.toString();
        if(val.length !== undefined){

            if(val.length <= 3)
            {
                offsetRectX = -28;
                offsetRectWidth = 28;
            }else{
                offsetRectX = -parseInt(val.length) * 8;
                offsetRectWidth = parseInt(val.length) * 8;
            }
        }

        return (
            <g>
                <rect x={x + offsetRectX} y={y-7} width={offsetRectWidth} height="15" fill="#C23579" rx="3" ry="3"></rect>
                <text textAnchor="end" x={x-6} y={y+4} fill="#ffffff" style={{fontSize:'11px'}}>{value}</text>
            </g>
        );
    };

    renderSleepLabelContent = (props) => {
        const { value } = props;

        const x = props.viewBox.x;
        const y = props.viewBox.y;

        var offsetRectX = -2;
        var offset = 37;
        let offsetRectWidth = 46;

        return (
            <g>
                <rect x={x-offset+offsetRectX} y={y-7} width={offsetRectWidth} height="15" fill="#C23579" rx="3" ry="3"></rect>
                <text textAnchor="end" x={x + 4} y={y+4} fill="#ffffff" style={{fontSize:'11px'}}>{value}</text>
            </g>
        );
    };

    renderWeightReferenceLabelContent = (props) => {
        const { value } = props;
        const x = props.viewBox.x;
        const y = props.viewBox.y;

        var offsetRectX = -2;
        var offset = 28;
        let offsetRectWidth = 28;
        if(value.length<3)
        {
            offsetRectX = 4;
            offsetRectWidth = 20;
        }

        offsetRectX-=3;

        let text = numeral(value).format('0.0');
        // console.group("renderWeightReferenceLabelContent");
        // console.log(text.length, text);
        // console.groupEnd();
        if(text.length>=5)
        {
            offsetRectX = -11;
            offsetRectWidth = 34;
        }

        return (
            <g>
                <rect x={x-offset+offsetRectX} y={y-7} width={offsetRectWidth} height="15" fill="#C23579" rx="3" ry="3"></rect>
                <text textAnchor="end" x={x-8} y={y+4} fill="#ffffff" style={{fontSize:'11px'}}>{text}</text>
            </g>
        );
    };

    renderMEWCStartLabel = (props) => {
        const { value } = props;
        let x = props.viewBox.x;
        let y = props.viewBox.y;
        if(isNaN(x)){
            x = 0;
        }

        var offsetRectX = -2;
        var offset = 28;
        let offsetRectWidth = 28;
        if(value.length<3)
        {
            offsetRectX = 4;
            offsetRectWidth = 20;
        }

        offsetRectX-=3;
        this.mewcStartLabelY = y - 2;
        return (
            <g key={offsetRectX}>
                <text textAnchor="end" x={x+10} y={this.mewcStartLabelY} fill="gray" style={{fontSize:'11px'}}>{value}</text>
            </g>
        );
    };

    renderCalendar  = (props) => {
        var {x, y, day} = props;

        if(isNaN(y))
        {
            y = 0;
        }

        const domain = props.xAxis.domain;
        const maskBarIndex = domain.indexOf(props.day);

        this.state.maskBarPositions[maskBarIndex] = props.tooltipPosition.x;

        const date = this.convertToDate(day);
        const weekName = this.getDayOfWeek(date);
        let whichDay = this.formatDate(date);
        // console.log(x);

        let fixX = 3;

        // whichDay = "1/1";

        switch(whichDay.length)
        {
            case 5:
                fixX = 10;
                break;

            case 4:
                fixX = 5;
                break;

            case 3:
                fixX = 3;
        }

        return (
            <g id={'calendar_' + whichDay}>
                <text x={x + 3} y={y + 30} fill="#BDBDBD" style={{fontSize:'13px'}}>{weekName}</text>
                <text x={x - fixX} y={y + 60} fill="#8D8D8D" style={{fontSize:'14px',fontWeight:'bold'}}>{whichDay}</text>
                {/* <circle fill="32B5FB" fill-opacity="0.1" cx={x + fixX} cy={y + 55} r="21.5"></circle> */}
            </g>
        )
    }

    getDayOfWeek(date) {
        var dayOfWeek = this.convertToDate(date).getDay();
        return isNaN(dayOfWeek) ? null : ['S', 'M', 'T', 'W', 'T', 'F', 'S'][dayOfWeek];
    }

    formatDate(date) {
        if(date == undefined) return ;
        var d = this.convertToDate(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate();

        return [day, month].join('/');
    }

    getConditionCount(feelings)
    {
        let count = 1;
        if(feelings.conditions!=null && false) // new CR dont show conditions
        {
            count += feelings.conditions.length;
        }

        if(feelings.memo!=null)
        {
            count ++;
        }

        // console.group("getConditionCount");
        // console.log(count, feelings);
        // console.groupEnd();

        return count;
    }

    renderConditionIcons  = (props) => {
        var {x, y, payload} = props;

        const domain = props.xAxis.domain;
        const index = domain.indexOf(props.day);

        this.state.conditionIconPositions[index] = x;

        const feelings = payload.feelings;

        let icon = this.getConditionIcon(feelings, x, y , 45);

        // console.group("renderConditionIcons");
        // console.log(feelings);
        // console.groupEnd();
        if(isNaN(y))
        {
            y = 0;
        }

        return (
            <g x={x} y={y}>
                {icon}
            </g>
        )
    }

    getAllGoal(data){
        console.log(data)
        let goal = null
        if (data != null ) {
            goal =data !== undefined ?data : null;
            this.setState({
                weightHGoal: goal.weight ? parseFloat(goal.weight) : '',
                weightLGoal: goal.weight_to ? parseFloat(goal.weight_to) : '',
                glucoseBeforeMealHGoal: goal.glucose ? parseFloat(goal.glucose) : '',
                glucoseBeforeMealLGoal: goal.glucose_to ? parseFloat(goal.glucose_to) : '',
                glucoseAfterMealHGoal: goal.glucose_after_meal ? parseFloat(goal.glucose_after_meal) : '',
                glucoseAfterMealLGoal: goal.glucose_after_meal_to ? parseFloat(goal.glucose_after_meal_to) : '',
                spo2HGoal: goal.spo2 ? parseFloat(goal.spo2) : '',
                spo2LGoal: goal.spo2_to ? parseFloat(goal.spo2_to) : '',
            },()=>{
                console.log(goal.weight_to)
                console.log(this.state.weightLGoal)
            })
        }
    }

    initData()
    {
        let totalPage = this.getTotalPage(this.fullData.main);
        let curPage = 1;
        if(this.dataMonthDirection == null || this.dataMonthDirection=="pre")
        {
            curPage = totalPage;
        }else{
            curPage = 1;
        }

        this.setState({
            page:{
                curPage:curPage,
                totalPage:totalPage,
            }
        });
    }

    getConditionIcon(feelings, x, y, width)
    {
        if(feelings == null) return null;

        let icon;
        let conditionCount = this.getConditionCount(feelings);

        if(feelings.conditions!=null && feelings.conditions.length>0 && false) // false : new CR don't show conditions
        {
            //conditions 1:Dry Cough 2:Migraine 3:Dizziness 4:Heart Palpitations 5:Hot Flashes 6:Swelling
            switch(feelings.conditions[0])
            {
                //Dry Cough
                case 1:
                    icon = (
                        <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                    <stop stopColor="#69CBFF" offset="0%"></stop>
                                    <stop stopColor="#32B5FB" offset="100%"></stop>
                                </linearGradient>
                            </defs>
                            <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="Artboard" transform="translate(-1097.000000, -283.000000)" stroke="#FFFFFF">
                                    <g id="icon/35px/condition1" transform="translate(1097.000000, 283.000000)">
                                        <g id="Group-3">
                                            <circle id="Oval" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                            <path d="M12.3726747,13.5820147 C12.8136519,11.0145181 14.301927,9.54010305 16.8374999,9.15876952 C19.3730728,8.77743598 21.1980849,10.251851 22.3125362,13.5820147 C25.3264964,14.2441795 26.8334765,15.4728587 26.8334765,17.2680524 C26.8334765,19.063246 25.8547177,20.4001982 23.8972,21.278909 C24.1635968,23.9528134 23.0781499,25.4807587 20.6408593,25.8627451 C19.589305,26.0275508 18.3215186,25.6455644 16.8374999,24.7167861 C14.4659772,25.5506093 12.5235159,25.1171443 11.010116,23.4163911 C9.49671611,21.715638 9.38337739,19.6088227 10.6700998,17.0959453 L8.4,13.5820147 L12.3726747,13.5820147 Z" id="Path-7" fill="#FFFFFF" strokeLinecap="round" strokeLinejoin="round"></path>
                                        </g>
                                        {
                                            conditionCount>1?(
                                            <g>
                                                <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                                <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                            </g>
                                            ):""
                                        }
                                    </g>
                                </g>
                            </g>
                        </svg>
                    );
                    break;

                //Migraine
                case 2:
                    icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                <stop stopColor="#69CBFF" offset="0%"></stop>
                                <stop stopColor="#32B5FB" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1149.000000, -283.000000)">
                                <g id="icon/35px/condition2" transform="translate(1149.000000, 283.000000)">
                                    <g id="Group-10">
                                        <circle id="Oval" stroke="#FFFFFF" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                        <g id="Group-16" transform="translate(7.700000, 7.700000)" fill="#FFFFFF" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                                            <g id="Group-5" transform="translate(0.000000, 0.269231)">
                                                <path d="M6.5826862,18.8307692 L6.58271361,17.6793701 C6.58271361,17.1270702 6.13498609,16.6793426 5.5826862,16.6793426 C5.53080929,16.6793426 5.47901103,16.6833793 5.42776043,16.6914162 C4.35524557,16.8596024 3.75270699,16.7821304 3.62014471,16.4590002 C3.13399856,15.2739836 2.70147907,14.088967 2.32258625,12.9039504 L0.497237569,12.9039504 L2.32258625,7.47442157 C2.32258625,2.72174528 4.7301334,0.236770973 9.5452277,0.0194986419 C16.7678692,-0.306409854 18.0077101,3.49845503 18.0077101,8.04049296 C18.0077101,10.4927868 16.569402,12.7064476 13.6927858,14.6814753 L13.6927858,18.8307692 L6.5826862,18.8307692 Z" id="Path-8"></path>
                                            </g>
                                        </g>
                                        <g id="Group-13" transform="translate(14.000000, 9.100000)" fill="#4FC0FD" stroke="#4BBFFD">
                                            <path d="M5.16954433,1.44047012 L4.70646794,1.44047012 L4.16648934,4.89208854 L4.51054505,4.89208854 C4.58921529,4.89553676 4.58921529,4.89553676 4.66608991,4.91260102 C4.92381901,4.98178014 5.0970892,5.20866254 5.1099283,5.46152753 L5.61020399,4.53674919 L5.17103674,4.53674919 C5.09839632,4.53381055 5.09839632,4.53381055 5.02717035,4.51924594 C4.70546628,4.43979072 4.50908478,4.11458686 4.58854,3.79288279 L5.16954433,1.44047012 Z" id="Path-2" transform="translate(4.990208, 4.789952) rotate(20.000000) translate(-4.990208, -4.789952) "></path>
                                            <path d="M1.46594977,1.45267793 L1.36588529,1.45267793 L1.19298633,2.55787218 L1.46594977,1.45267793 Z M1.06724917,3.36160164 L0.991200521,3.8477152 L1.08396681,3.8477152 C1.16263705,3.85116342 1.16263705,3.85116342 1.23951167,3.86822768 C1.38897052,3.90834512 1.51002653,4.00149689 1.58786375,4.1219951 L1.75444553,3.81406246 L1.64894814,3.81406246 C1.57630771,3.81112381 1.57630771,3.81112381 1.50508174,3.7965592 C1.28261885,3.7416148 1.12008417,3.56915543 1.06724917,3.36160164 Z" id="Path-2" transform="translate(1.474685, 3.805776) rotate(5.000000) translate(-1.474685, -3.805776) "></path>
                                            <path d="M7.45942709,5.19726012 L7.35936261,5.19726012 L7.18646365,6.30245436 L7.45942709,5.19726012 Z M7.06072649,7.10618383 L6.98467784,7.59229739 L7.07744412,7.59229739 C7.15611436,7.59574561 7.15611436,7.59574561 7.23298899,7.61280986 C7.38244784,7.6529273 7.50350384,7.74607908 7.58134107,7.86657729 L7.74792284,7.55864464 L7.64242545,7.55864464 C7.56978503,7.555706 7.56978503,7.555706 7.49855906,7.54114138 C7.27609616,7.48619698 7.11356148,7.31373761 7.06072649,7.10618383 Z" id="Path-2" transform="translate(7.468162, 7.550358) rotate(55.000000) translate(-7.468162, -7.550358) "></path>
                                        </g>
                                    </g>
                                    {
                                        conditionCount>1?(
                                        <g>
                                            <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                            <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        </g>
                                        ):""
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                    );
                    break;

                // Dizziness
                case 3:
                    icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                <stop stopColor="#69CBFF" offset="0%"></stop>
                                <stop stopColor="#32B5FB" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1201.000000, -283.000000)">
                                <g id="icon/35px/condition3" transform="translate(1201.000000, 283.000000)">
                                    <g id="Group-11">
                                        <circle id="Oval" stroke="#FFFFFF" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                        <g id="Group-8" transform="translate(9.100000, 5.600000)" strokeLinecap="round" strokeLinejoin="round">
                                            <g id="Group-15" transform="translate(0.000000, 4.189042)" fill="#FFFFFF" stroke="#FFFFFF">
                                                <g id="Group-5" transform="translate(0.000000, 0.564884)">
                                                    <path d="M5.45956895,15.6179225 L5.45958394,14.8602156 C5.45958394,14.3079225 5.01186198,13.8602006 4.45956895,13.8602006 C4.41521034,13.8602006 4.37090087,13.8631521 4.32693416,13.8690355 C3.54649486,13.97347 3.10501247,13.9007306 3.00248698,13.6508172 C2.59928556,12.6679844 2.24056119,11.6851517 1.92631387,10.7023189 L3.01980663e-13,10.7023189 L1.92631387,5.45978416 C1.92631387,2.01091129 3.92309289,0.196373853 7.91665092,0.0161718449 C13.906988,-0.254131167 14.9352912,2.90155962 14.9352912,6.66864929 C14.9352912,8.70254049 13.7423827,10.5385134 11.3565657,12.1765681 L11.3565657,15.6179225 L5.45956895,15.6179225 Z" id="Path-8"></path>
                                                </g>
                                            </g>
                                            <g id="noun_Dizzy_808346" transform="translate(0.906380, 0.000000)" strokeWidth="0.2">
                                                <g id="Group">
                                                    <path d="M4.82968374,5.61773368 L4.90601675,5.40086427 L4.93592256,5.31553861 C3.58388717,4.84143741 2.46315126,4.34307695 1.69271067,3.87859581 C0.912231769,3.42268906 0.527848002,2.95988096 0.553989444,2.75848729 C0.553571181,2.73778327 0.555662497,2.7220984 0.55879947,2.70975964 C0.576784782,2.58846335 0.759356615,2.41718462 1.17887448,2.29735225 C1.58939969,2.17710161 1.80062254,2.10641515 2.5357199,2.09533118 L2.52923682,1.67706811 C1.77029847,1.68940687 1.53167938,1.7592568 1.06155169,1.89602883 C0.599998383,2.03342825 0.247611741,2.2367041 0.151829497,2.61314087 C0.139908999,2.6604046 0.135517237,2.71101443 0.135517237,2.75848729 C0.161240416,3.30348408 0.676749657,3.74077812 1.47688692,4.23683813 C2.27702419,4.71846807 3.4011062,5.21724678 4.75021376,5.69323016 C4.76610775,5.69887672 4.78116522,5.70452327 4.79726835,5.70996069 L4.82968374,5.61773368 Z" id="Path" stroke="#FFFFFF" fill="#FFFFFF"></path>
                                                    <path d="M6.67213511,7.00886165 C6.74465877,7.01860643 7.32146868,7.1518043 8.7539538,7.48485375 C10.1864389,7.8179032 13.113635,8.33709417 13.1219584,8.33815903 C13.4622154,8.38144926 13.7959893,8.42013859 14.1161697,8.45046267 L14.1556956,8.0342909 C13.7660835,7.99727462 13.3595318,7.95001089 12.9381317,7.89354538 C11.4530762,7.66165607 10.2205066,7.4292454 9.24042289,7.19631334 C8.26033919,6.96338129 7.62771487,6.81355403 7.34254993,6.74683156 L6.67213511,7.00886165 Z" id="Path" stroke="#45BDFD" fill="#4BBFFD"></path>
                                                    <path d="M18.3782704,7.18224672 C18.1130916,7.29162251 17.7165782,7.37485686 17.2207274,7.42002927 L17.2596258,7.8366193 C17.7803634,7.78830991 18.2092922,7.70340251 18.5372104,7.56914006 C18.8607369,7.43634153 19.1127404,7.24331312 19.1850999,6.94320937 C19.1953474,6.89469085 19.2009939,6.84638147 19.2005756,6.79765382 C19.1809173,6.31163212 18.7630725,5.9182557 18.1193656,5.48263471 C17.4670843,5.05328766 16.5464873,4.60783748 15.425124,4.17284388 L15.2739219,4.5628742 L15.2735036,4.5628742 C16.3762542,4.9899208 17.2765655,5.42826051 17.8893209,5.83188437 C18.5106507,6.23027995 18.8017618,6.62072854 18.7823126,6.79786295 C18.7823126,6.81605739 18.7802213,6.83425184 18.776666,6.85328281 C18.7584716,6.94550981 18.649514,7.07119787 18.3782704,7.18224672 Z" id="Path" stroke="#FFFFFF" fill="#FFFFFF"></path>
                                                    <path d="M6.56589377,1.94078298 L6.50921912,2.35528168 C7.61740714,2.50773858 8.82033175,2.72649017 10.0705201,3.01111819 C10.850999,3.18846173 10.8622304,3.18423918 11.577042,3.38709677 L11.691437,2.98493683 C10.9693058,2.77977879 10.9503365,2.78211915 10.1631654,2.60310256 C8.90189305,2.31596496 7.68725708,2.09512205 6.56589377,1.94078298 Z" id="Path" stroke="#FFFFFF" fill="#FFFFFF"></path>
                                                    <polygon id="Path" stroke="#FFFFFF" fill="#FFFFFF" points="5.05222144 0.935901171 4.69170778 0 4.16817686 0.855633785 3.16662745 0.909421208 3.81842069 1.67154763 3.56051689 2.64054875 4.48648807 2.2565893 5.32860604 2.80135935 5.24889032 1.80174077 6.02784255 1.16925584"></polygon>
                                                    <polygon id="Path" stroke="#45BDFD" fill="#4BBFFD" points="4.94693046 6.76276716 5.61331041 7.50456048 5.7970448 6.52446091 6.70858677 6.12024525 5.83351745 5.64281006 5.73068104 4.65091858 5.00589 5.3359462 4.03045234 5.12725684 4.45797759 6.02810382 3.95832974 6.89083277"></polygon>
                                                    <polygon id="Path" stroke="#FFFFFF" fill="#FFFFFF" points="15.8235355 6.63906974 15.3556899 5.7471438 14.9327176 6.6609524 13.9394112 6.83047372 14.6778816 7.51548393 14.5321819 8.51211422 15.41192 8.02155495 16.3149258 8.46807191 16.1196439 7.48002849 16.8234898 6.75956284"></polygon>
                                                    <polygon id="Path" stroke="#FFFFFF" fill="#FFFFFF" points="13.4227114 4.01431763 14.162771 4.68333366 14.2431407 3.68899864 15.1082807 3.19224258 14.1877322 2.80794924 13.9825563 1.83199227 13.3327413 2.58850979 12.3406006 2.48263025 12.8598492 3.33432963 12.4519662 4.24472905"></polygon>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                    {
                                        conditionCount>1?(
                                        <g>
                                            <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                            <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        </g>
                                        ):""
                                    }

                                </g>
                            </g>
                        </g>
                    </svg>
                    );
                    break;

                // Heart Palpitations
                case 4:
                    icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                <stop stopColor="#69CBFF" offset="0%"></stop>
                                <stop stopColor="#32B5FB" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1357.000000, -283.000000)">
                                <g id="icon/35px/condition6" transform="translate(1357.000000, 283.000000)">
                                    <g id="Group-28">
                                        <g id="Group-21">
                                            <circle id="Oval" stroke="#FFFFFF" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                            <path d="M24.0496442,15.0857241 C22.4359028,13.9977069 21.1114545,14.2098793 19.2797476,15.184569 C19.502058,13.1211379 19.20842,11.8122586 17.6004718,10.7188103 C15.8125752,9.50406897 13.4258166,9.89293103 12.2744373,11.5856034 C10.3742993,14.3825862 11.0998856,18.9642069 12.1281614,23.752931 C12.2277304,24.2181897 12.3019545,24.6595517 12.6853856,24.9187931 C13.0981442,25.1986724 13.448989,25.1096034 13.900489,25.0317586 C18.7493166,24.2080517 23.3207993,23.1663793 25.2198511,20.3527414 C26.3650752,18.655 25.8422476,16.2953966 24.0496442,15.0857241 Z" id="Path" fill="#FFFFFF" transform="translate(18.459706, 17.560516) rotate(-35.000000) translate(-18.459706, -17.560516) "></path>
                                            <path d="M6.61020968,21.0149023 C6.57943382,21.0149023 6.54829589,21.0120057 6.51679589,21.0058506 C6.2517614,20.9547988 6.07833037,20.698092 6.12974416,20.4334195 C6.43098554,18.8736264 6.94077865,17.5806782 7.68845106,16.4799885 C8.94012347,14.6377816 11.1664855,13.7116092 13.2310028,14.1772299 C13.494589,14.2366092 13.6596924,14.4983851 13.6006752,14.7616092 C13.5412959,15.0248333 13.2802442,15.1888506 13.0162959,15.1312816 C11.3406407,14.7540057 9.52558899,15.516523 8.4976752,17.0296092 C7.82603727,18.0176954 7.36584761,19.1922471 7.08995106,20.6187988 C7.04433037,20.8519713 6.8397614,21.0149023 6.61020968,21.0149023 Z" id="Path" fill="#FFFFFF" transform="translate(9.866676, 17.536487) rotate(-50.000000) translate(-9.866676, -17.536487) "></path>
                                            <path d="M4.68990393,19.4180046 C4.62074875,19.4180046 4.55050737,19.4031597 4.48352462,19.3720218 C4.238766,19.2579701 4.13304186,18.9668666 4.24745565,18.7224701 C4.4603522,18.2666253 4.70764531,17.8303322 4.98317979,17.425539 C5.897766,16.0804528 7.29716255,15.1640563 9.02966255,14.7759184 C9.29288668,14.7150908 9.55466255,14.8827287 9.61331772,15.1459528 C9.67269703,15.409177 9.50686944,15.6705908 9.24364531,15.729608 C7.75771427,16.0623494 6.56361082,16.8389873 5.79095565,17.9751597 C5.54474875,18.3368666 5.32352462,18.727177 5.13307634,19.1355908 C5.05016255,19.3137287 4.87419703,19.4180046 4.68990393,19.4180046 Z" id="Path" fill="#FFFFFF" transform="translate(6.913345, 17.090722) rotate(-50.000000) translate(-6.913345, -17.090722) "></path>
                                            <path d="M22.2000873,20.9999976 C22.1685398,20.9999006 22.1366311,20.9968806 22.1043625,20.9905725 C21.8328587,20.9382405 21.6559636,20.6787499 21.7095783,20.4119332 C22.0237463,18.8394976 22.5507757,17.5368895 23.3209864,16.4289653 C24.6103885,14.574651 26.8957627,13.6474261 29.0104393,14.1236122 C29.2804299,14.1843399 29.4487711,14.4489173 29.3873673,14.7142492 C29.3255924,14.9795799 29.0574303,15.1442034 28.7870623,15.0853008 C27.0706933,14.6994551 25.207506,15.4628954 24.1486067,16.9859264 C23.4567248,17.9805056 22.9809504,19.1638417 22.6932218,20.6019548 C22.645654,20.8370153 22.4353945,21.0007212 22.2000873,20.9999976 Z" id="Path" fill="#FFFFFF" transform="translate(25.550000, 17.500000) scale(-1, 1) rotate(-50.000000) translate(-25.550000, -17.500000) "></path>
                                            <path d="M25.7047919,19.6 C25.6333729,19.6000303 25.5608256,19.5844398 25.4916365,19.5517024 C25.2388156,19.431792 25.129503,19.1255073 25.2475552,18.8682761 C25.4672214,18.3884924 25.7224186,17.9292682 26.0067956,17.5031793 C26.9507322,16.0873298 28.3955374,15.1223821 30.1845818,14.7131801 C30.4563961,14.6490551 30.7268148,14.8253473 30.7875054,15.102315 C30.8489438,15.3792824 30.6778023,15.6544436 30.4059872,15.7166636 C28.871559,16.067463 27.6387061,16.8852512 26.8412552,18.0811962 C26.5871471,18.4619322 26.358852,18.8727569 26.1623482,19.3026185 C26.0767982,19.4901113 25.895118,19.5999191 25.7047919,19.6 Z" id="Path" fill="#FFFFFF" transform="translate(28.000000, 17.150000) scale(-1, 1) rotate(-50.000000) translate(-28.000000, -17.150000) "></path>
                                        </g>
                                        <g id="noun_beating-heart_149361" transform="translate(3.266523, 11.000000)">
                                            <g id="Group">
                                                <g id="Group-18">
                                                    <g id="Group-17" transform="translate(0.000000, 0.900000)"></g>
                                                    <g id="Group-17" transform="translate(22.700000, 6.400000) scale(-1, 1) translate(-22.700000, -6.400000) translate(16.700000, 0.900000)"></g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                    {
                                        conditionCount>1?(
                                        <g>
                                            <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                            <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        </g>
                                        ):""
                                    }

                                </g>
                            </g>
                        </g>
                    </svg>
                    );
                    break;

                // Hot Flashes
                case 5:
                    icon = (
                        <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                            <defs>
                                <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                    <stop stopColor="#69CBFF" offset="0%"></stop>
                                    <stop stopColor="#32B5FB" offset="100%"></stop>
                                </linearGradient>
                            </defs>
                            <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g id="Artboard" transform="translate(-1253.000000, -283.000000)">
                                    <g id="icon/35px/condition4" transform="translate(1253.000000, 283.000000)">
                                        <g id="Group-12">
                                            <circle id="Oval" stroke="#FFFFFF" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                            <g id="Group-20" transform="translate(10.500000, 7.000000)">
                                                <path d="M4.80430155,20.9453441 L4.80429338,20.2788631 C4.80429338,19.7265829 4.35658179,19.2788713 3.80430155,19.2788713 C3.76236388,19.2788713 3.72046774,19.2815095 3.67886133,19.2867702 C2.96542344,19.3769773 2.560954,19.3056855 2.465453,19.0728949 C2.08165341,18.1373554 1.74019066,17.201816 1.44106474,16.2662766 L1.66977543e-13,16.2662766 L1.44106474,11.9798065 C1.44106474,8.22769364 3.34175987,6.26587182 7.14315011,6.09434103 C12.8452355,5.83704485 13.8240573,8.84088555 13.8240573,12.426705 C13.8240573,14.3627264 12.6885509,16.1103534 10.4175381,17.6695857 L10.4175381,20.9453441 L4.80430155,20.9453441 Z" id="Path-8" stroke="#FFFFFF" fill="#FFFFFF" strokeLinecap="round" strokeLinejoin="round"></path>
                                                <path d="M9.8,13.9458595 C9.8,14.3503742 10.0071747,14.5526316 10.421524,14.5526316 C10.8358734,14.5526316 11.0430481,14.3503742 11.0430481,13.9458595 L10.431343,11.2189537 C10.4192544,11.1650644 10.3657688,11.1311783 10.3118796,11.1432668 C10.2719347,11.1522273 10.2414853,11.1846296 10.235022,11.2250537 L9.8,13.9458595 Z" id="Path-10" stroke="#44BCFC" strokeWidth="0.5" fill="#44BCFC"></path>
                                                <g id="Group-19" transform="translate(4.973684, 0.000000)" stroke="#FFFFFF" strokeLinecap="round" strokeLinejoin="round">
                                                    <path d="M0.594033638,0 C0.198011213,0.531282665 3.91878776e-13,0.965603925 -1.12132525e-14,1.30296378 C-6.15768003e-13,1.80900356 0.671029557,2.35652127 0.594033638,2.99682567 C0.542703024,3.42369526 0.344691812,3.82475337 -1.12132525e-14,4.2" id="Path-11"></path>
                                                    <path d="M2.69403364,0 C2.29801121,0.531282665 2.1,0.965603925 2.1,1.30296378 C2.1,1.80900356 2.77102956,2.35652127 2.69403364,2.99682567 C2.64270302,3.42369526 2.44469181,3.82475337 2.1,4.2" id="Path-11"></path>
                                                    <path d="M4.79403364,1.82076576e-13 C4.39801121,0.531282665 4.2,0.965603925 4.2,1.30296378 C4.2,1.80900356 4.87102956,2.35652127 4.79403364,2.99682567 C4.74270302,3.42369526 4.54469181,3.82475337 4.2,4.2" id="Path-11"></path>
                                                </g>
                                            </g>
                                        </g>
                                        {
                                            conditionCount>1?(
                                            <g>
                                                <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                                <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                            </g>
                                            ):""
                                        }
                                    </g>
                                </g>
                            </g>
                        </svg>
                    );
                    break;

                // Swelling
                case 6:
                    icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <defs>
                            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="linearGradient-1">
                                <stop stopColor="#69CBFF" offset="0%"></stop>
                                <stop stopColor="#32B5FB" offset="100%"></stop>
                            </linearGradient>
                        </defs>
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1305.000000, -283.000000)" stroke="#FFFFFF">
                                <g id="icon/35px/condition5" transform="translate(1305.000000, 283.000000)">
                                    <g id="Group-14">
                                        <circle id="Oval" strokeWidth="2" fill="url(#linearGradient-1)" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                        <path d="M21.7182774,9.67272727 C17.4844369,21.2783459 8.03296416,22.3057428 7.7,23.9216104 C8.30933267,25.3146069 10.293072,25.226202 11.1391149,25.226202 C11.9851579,25.226202 15.4823732,23.8163889 16.7711045,23.6194227 C18.0598359,23.4224565 19.2400379,23.9216104 20.0423948,23.6194227 C20.8447517,23.317235 21.3052626,22.844744 21.3052626,22.3057428 C21.3052626,21.7667416 20.998634,20.025496 21.3052626,19.2258243 C21.5096817,18.6927098 23.3382305,17.228659 26.7909091,14.8336718 C23.4091546,11.3930421 21.7182774,9.67272727 21.7182774,9.67272727 Z" id="Path-12" fill="#FFFFFF" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M19.7909091,8.46152344 C19.5579723,9.53623971 19.2971709,10.4303493 19.008505,11.1438521 C18.719839,11.8573549 18.2571704,12.7514645 17.6204989,13.8261808" id="Path-13" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M27.3352983,15.8982466 C27.1261545,16.4836998 26.8110799,17.1277539 26.3900746,17.8304088 C25.9690692,18.5330638 25.5123561,19.1771178 25.0199352,19.762571" id="Path-13" strokeLinecap="round" strokeLinejoin="round" transform="translate(26.177617, 17.830409) scale(-1, 1) rotate(-90.000000) translate(-26.177617, -17.830409) "></path>
                                    </g>
                                    {
                                        conditionCount>1?(
                                        <g>
                                            <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                            <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        </g>
                                        ):""
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                    );
                    break;
            }

            return icon;
        }

        switch(feelings.feeling)
        {
            case 1:
                icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1148.000000, -227.000000)">
                                <g id="icon/35px/face1" transform="translate(1148.000000, 227.000000)">
                                    <g id="Group-30">
                                        <circle id="Oval" fill="#FFFFFF" fillRule="nonzero" cx="18.5" cy="17.5" r="16.5"></circle>
                                        <g id="Group-29" fill="#F96E6E">
                                            <path d="M17.9331168,0.295555556 C8.48291112,0.295555556 0.822005726,7.95646095 0.822005726,17.4066667 C0.822005726,26.8568724 8.48291112,34.5177778 17.9331168,34.5177778 C27.3833226,34.5177778 35.0442279,26.8568724 35.0442279,17.4066667 C35.0442279,7.95646095 27.3833226,0.295555556 17.9331168,0.295555556 Z M17.9331168,32.1222222 C9.77157553,32.1222222 3.15533906,25.5059857 3.15533906,17.3444444 C3.15533906,9.18290314 9.77157553,2.56666667 17.9331168,2.56666667 C26.0946581,2.56666667 32.7108946,9.18290314 32.7108946,17.3444444 C32.7108946,25.5059857 26.0946581,32.1222222 17.9331168,32.1222222 Z" id="Shape" fillRule="nonzero"></path>
                                            <path d="M17.9331168,20.7277778 C15.0146283,20.728306 12.2099841,21.8602001 10.1086724,23.8855556 C9.66754995,24.3364486 9.66470191,25.0563077 10.1022428,25.5106771 C10.5397837,25.9650464 11.2592378,25.9893553 11.7264502,25.5655556 C15.1947676,22.2069616 20.7025771,22.2069616 24.1708946,25.5655556 C24.3794757,25.7689432 24.6574168,25.8856785 24.9486724,25.8922222 C25.265285,25.8902575 25.5678786,25.7613751 25.7886724,25.5344444 C26.2330377,25.0682909 26.2156309,24.3302419 25.7497835,23.8855556 C23.6522126,21.8592874 20.8495472,20.7270663 17.9331168,20.7277778 Z" id="Path"></path>
                                            <path d="M25.5942279,12.6311111 L21.2775613,13.8833333 C20.8774238,14.0000401 20.5699438,14.3213524 20.4709461,14.726235 C20.3719484,15.1311176 20.496473,15.5580592 20.7976128,15.846235 C21.0987526,16.1344108 21.5307571,16.2400401 21.9308946,16.1233333 L26.2475613,14.8711111 C26.8661202,14.6906981 27.2213076,14.0430034 27.0408946,13.4244445 C26.8604816,12.8058856 26.2127869,12.4506981 25.5942279,12.6311111 Z" id="Path"></path>
                                            <path d="M14.2542279,16.17 C14.8348201,16.17 15.3270609,15.7430818 15.409169,15.1683249 C15.4912771,14.5935681 15.138263,14.0458991 14.5808946,13.8833333 L10.2720057,12.6311111 C9.87186826,12.5144043 9.43986367,12.6200336 9.13872391,12.9082095 C8.83758415,13.1963853 8.71305952,13.6233269 8.81205724,14.0282095 C8.91105496,14.4330921 9.21853492,14.7544044 9.61867239,14.8711111 L13.9275613,16.1233333 C14.0337331,16.1540837 14.1436929,16.1697923 14.2542279,16.17 Z" id="Path"></path>
                                        </g>
                                    </g>
                                    {
                                        // conditionCount>1?(
                                        // <g>
                                        //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                        //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        // </g>
                                        // ):""
                                        //new CR dont show count
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                );
                break;

            case 2:
                icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1199.000000, -227.000000)" fill="#AE6EF9">
                                <g id="icon/35px/face2" transform="translate(1199.000000, 227.000000)">
                                    <g id="Group-7">
                                        <path d="M17.7231168,0.295555556 C8.27291112,0.295555556 0.612005726,7.95646095 0.612005726,17.4066667 C0.612005726,26.8568724 8.27291112,34.5177778 17.7231168,34.5177778 C27.1733226,34.5177778 34.8342279,26.8568724 34.8342279,17.4066667 C34.8342279,12.8685178 33.0314553,8.51623978 29.8224995,5.30728397 C26.6135437,2.09832816 22.2612657,0.295555556 17.7231168,0.295555556 Z M17.7231168,32.1222222 C9.56157553,32.1222222 2.94533906,25.5059857 2.94533906,17.3444444 C2.94533906,9.18290314 9.56157553,2.56666667 17.7231168,2.56666667 C25.8846581,2.56666667 32.5008946,9.18290314 32.5008946,17.3444444 C32.5008946,21.2637548 30.9439546,25.0225404 28.1725837,27.7939113 C25.4012128,30.5652822 21.6424272,32.1222222 17.7231168,32.1222222 Z" id="Shape" fillRule="nonzero"></path>
                                        <circle id="Oval" cx="23.7975613" cy="13.3311111" r="2.44222222"></circle>
                                        <path d="M11.3534286,15.7734003 C12.3447272,15.7732746 13.2376115,15.1739505 13.6132288,14.2565712 C13.9888462,13.339192 13.7726729,12.2857686 13.066116,11.5904626 C12.3595591,10.8951566 11.3028017,10.695919 10.3915695,11.0862122 C9.48033718,11.4765053 8.89542133,12.378894 8.91120633,13.370067 C8.93657294,14.7018856 10.0213743,15.7694131 11.3534286,15.7734003 Z" id="Path"></path>
                                        <path d="M17.7231168,20.7277778 C14.8046283,20.728306 11.9999841,21.8602001 9.89867239,23.8855556 C9.58380413,24.1711667 9.44920984,24.6054363 9.54736351,25.0190565 C9.64551718,25.4326766 9.96088065,25.7601694 10.3705038,25.873856 C10.780127,25.9875426 11.2191647,25.8694258 11.5164502,25.5655556 C14.9847676,22.2069616 20.4925771,22.2069616 23.9608946,25.5655556 C24.1694757,25.7689432 24.4474168,25.8856785 24.7386724,25.8922222 C25.0576299,25.8905993 25.3627669,25.7618259 25.5864502,25.5344444 C26.0413776,25.0789505 26.0413776,24.3410495 25.5864502,23.8855556 C23.477283,21.8480291 20.6556814,20.714923 17.7231168,20.7277778 Z" id="Path"></path>
                                    </g>
                                    {
                                        // conditionCount>1?(
                                        // <g>
                                        //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                        //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        // </g>
                                        // ):""
                                        //new CR dont show count
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                );
                break;

            case 3:
                icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1251.000000, -228.000000)" fill="#32B5FB">
                                <g id="icon/35px/face3" transform="translate(1251.000000, 228.000000)">
                                    <g id="Group-23">
                                        <path d="M17.29,0.295555556 C7.83979428,0.295555556 0.178888889,7.95646095 0.178888889,17.4066667 C0.178888889,26.8568724 7.83979428,34.5177778 17.29,34.5177778 C26.7402057,34.5177778 34.4011111,26.8568724 34.4011111,17.4066667 C34.4011111,12.8685178 32.5983385,8.51623978 29.3893827,5.30728397 C26.1804269,2.09832816 21.8281488,0.295555556 17.29,0.295555556 Z M17.29,32.1222222 C9.1284587,32.1222222 2.51222222,25.5059857 2.51222222,17.3444444 C2.51222222,9.18290314 9.1284587,2.56666667 17.29,2.56666667 C25.4515413,2.56666667 32.0677778,9.18290314 32.0677778,17.3444444 C32.0677778,25.5059857 25.4515413,32.1222222 17.29,32.1222222 Z" id="Shape" fillRule="nonzero"></path>
                                        <path d="M12.4444444,22.9444444 L22.5555556,22.9444444" id="Line-2" stroke="#32B5FB" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                                        <path d="M23.4425339,15.7734003 C24.4338326,15.7732746 25.3267169,15.1739505 25.7023342,14.2565712 C26.0779516,13.339192 25.8617783,12.2857686 25.1552214,11.5904626 C24.4486645,10.8951566 23.3919071,10.695919 22.4806748,11.0862122 C21.5694426,11.4765053 20.9845267,12.378894 21.0003117,13.370067 C21.0215499,14.7036577 22.1087741,15.7735694 23.4425339,15.7734003 Z" id="Path"></path>
                                        <path d="M10.9980895,15.7734003 C11.9893881,15.7732746 12.8822725,15.1739505 13.2578898,14.2565712 C13.6335071,13.339192 13.4173338,12.2857686 12.7107769,11.5904626 C12.0042201,10.8951566 10.9474627,10.695919 10.0362304,11.0862122 C9.12499812,11.4765053 8.54008227,12.378894 8.55586728,13.370067 C8.58123388,14.7018856 9.66603523,15.7694131 10.9980895,15.7734003 Z" id="Path"></path>
                                    </g>
                                    {
                                        // conditionCount>1?(
                                        // <g>
                                        //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                        //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        // </g>
                                        // ):""
                                        //new CR dont show count
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                );
                break;

            case 4:
                icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1300.000000, -227.000000)">
                                <g id="icon/35px/face4" transform="translate(1300.000000, 227.000000)">
                                    <g id="Group-27">
                                        <circle id="Oval-Copy-2" fill="#FFFFFF" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                        <g id="Group-24" fill="#7ED321">
                                            <path d="M17.29,0.295555556 C7.83979428,0.295555556 0.178888889,7.95646095 0.178888889,17.4066667 C0.178888889,26.8568724 7.83979428,34.5177778 17.29,34.5177778 C26.7402057,34.5177778 34.4011111,26.8568724 34.4011111,17.4066667 C34.4011111,12.8685178 32.5983385,8.51623978 29.3893827,5.30728397 C26.1804269,2.09832816 21.8281488,0.295555556 17.29,0.295555556 Z M17.29,32.1222222 C9.1284587,32.1222222 2.51222222,25.5059857 2.51222222,17.3444444 C2.51222222,9.18290314 9.1284587,2.56666667 17.29,2.56666667 C25.4515413,2.56666667 32.0677778,9.18290314 32.0677778,17.3444444 C32.0677778,25.5059857 25.4515413,32.1222222 17.29,32.1222222 Z" id="Shape" fillRule="nonzero"></path>
                                            <path d="M26.0866667,20.2611111 C25.5752659,19.8710835 24.8446779,19.9684952 24.4533333,20.4788889 C22.751582,22.7169759 20.1015816,24.0310671 17.29,24.0310671 C14.4784184,24.0310671 11.828418,22.7169759 10.1266667,20.4788889 C9.87380202,20.1468304 9.46299434,19.9748973 9.04899091,20.0278553 C8.63498747,20.0808132 8.28068525,20.3506166 8.11954646,20.7356331 C7.95840767,21.1206495 8.01491313,21.5623859 8.26777778,21.8944444 C10.4109195,24.7109966 13.746899,26.3645297 17.2861111,26.3645297 C20.8253233,26.3645297 24.1613027,24.7109966 26.3044444,21.8944444 C26.6944721,21.3830437 26.5970603,20.6524557 26.0866667,20.2611111 Z" id="Path"></path>
                                            <path d="M23.4425339,15.7734003 C24.4338326,15.7732746 25.3267169,15.1739505 25.7023342,14.2565712 C26.0779516,13.339192 25.8617783,12.2857686 25.1552214,11.5904626 C24.4486645,10.8951566 23.3919071,10.695919 22.4806748,11.0862122 C21.5694426,11.4765053 20.9845267,12.378894 21.0003117,13.370067 C21.0215499,14.7036577 22.1087741,15.7735694 23.4425339,15.7734003 Z" id="Path"></path>
                                            <path d="M10.9980895,15.7734003 C11.9893881,15.7732746 12.8822725,15.1739505 13.2578898,14.2565712 C13.6335071,13.339192 13.4173338,12.2857686 12.7107769,11.5904626 C12.0042201,10.8951566 10.9474627,10.695919 10.0362304,11.0862122 C9.12499812,11.4765053 8.54008227,12.378894 8.55586728,13.370067 C8.58123388,14.7018856 9.66603523,15.7694131 10.9980895,15.7734003 Z" id="Path"></path>
                                        </g>
                                    </g>
                                    {
                                        // conditionCount>1?(
                                        // <g>
                                        //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                        //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                        // </g>
                                        // ):""
                                        //new CR dont show count
                                    }
                                </g>
                            </g>
                        </g>
                    </svg>
                );
                break;

            case 5:
                icon = (
                    <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                        <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                            <g id="Artboard" transform="translate(-1354.000000, -228.000000)">
                                <g id="icon/35px/face5" transform="translate(1354.000000, 228.000000)">
                                    <g id="Group-26">
                                        <circle id="Oval-Copy-2" fill="#FFFFFF" fillRule="nonzero" cx="17.5" cy="17.5" r="16.5"></circle>
                                        <g id="Group-25" fill="#F2E000">
                                            <path d="M17.2122222,0.295555556 C7.7620165,0.295555556 0.101111111,7.95646095 0.101111111,17.4066667 C0.101111111,26.8568724 7.7620165,34.5177778 17.2122222,34.5177778 C26.6624279,34.5177778 34.3233333,26.8568724 34.3233333,17.4066667 C34.3233333,12.8685178 32.5205607,8.51623978 29.3116049,5.30728397 C26.1026491,2.09832816 21.750371,0.295555556 17.2122222,0.295555556 Z M17.2122222,32.1222222 C9.05068092,32.1222222 2.43444444,25.5059857 2.43444444,17.3444444 C2.43444444,9.18290314 9.05068092,2.56666667 17.2122222,2.56666667 C25.3737635,2.56666667 31.99,9.18290314 31.99,17.3444444 C31.99,25.5059857 25.3737635,32.1222222 17.2122222,32.1222222 Z" id="Shape" fillRule="nonzero"></path>
                                            <path d="M7.37333333,18.0366667 C7.0110106,18.0329852 6.66810184,18.2001172 6.44777778,18.4877778 C6.21642172,18.7729783 6.13285564,19.1504665 6.22222222,19.5066667 C7.54933579,24.4707966 12.0465356,27.9236487 17.185,27.9236487 C22.3234644,27.9236487 26.8206642,24.4707966 28.1477778,19.5066667 C28.2486887,19.1567601 28.1780744,18.77974 27.9573734,18.49007 C27.7366725,18.2004 27.391918,18.0322486 27.0277778,18.0366667 L7.37333333,18.0366667 Z M17.2122222,25.5888889 C13.7034512,25.5834412 10.5143616,23.5493355 9.03,20.37 L25.3633333,20.37 C23.8837585,23.5391857 20.7097319,25.5714108 17.2122222,25.5888889 Z" id="Shape" fillRule="nonzero"></path>
                                            <path d="M19.2655556,13.7277778 C19.800435,14.0860385 20.5244191,13.9433301 20.8833333,13.4088889 C21.3576839,12.7077336 22.1964711,12.3464341 23.0318498,12.4834362 C23.8672285,12.6204383 24.5466751,13.2307281 24.7722222,14.0466667 C24.9089139,14.5579876 25.3707323,14.9147026 25.9,14.9177778 C26.0007916,14.929145 26.1025417,14.929145 26.2033333,14.9177778 C26.8238081,14.7471651 27.1914405,14.1090107 27.0277778,13.4866667 C26.5737268,11.773375 25.1569165,10.4857578 23.4081446,10.197093 C21.6593727,9.90842817 19.9039112,10.6724074 18.9233333,12.1488889 C18.595616,12.6818126 18.7465941,13.3783707 19.2655556,13.7277778 Z" id="Path"></path>
                                            <path d="M8.29111111,14.8788889 C8.39190274,14.8902561 8.49365282,14.8902561 8.59444444,14.8788889 C9.12371214,14.8758137 9.58553057,14.5190988 9.72222222,14.0077778 C9.94776937,13.1918393 10.6272159,12.5815495 11.4625947,12.4445473 C12.2979734,12.3075452 13.1367606,12.6688447 13.6111111,13.37 C13.9888558,13.8245493 14.6468361,13.924818 15.1428269,13.603416 C15.6388177,13.2820139 15.8161138,12.6404861 15.5555556,12.11 C14.5721828,10.6434943 12.8225076,9.88697413 11.0804809,10.1750785 C9.33845429,10.4631829 7.92551667,11.7427506 7.46666667,13.4477778 C7.30300391,14.0701218 7.67063634,14.7082762 8.29111111,14.8788889 Z" id="Path"></path>
                                        </g>
                                        {
                                            // conditionCount>1?(
                                            // <g>
                                            //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                            //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                            // </g>
                                            // ):""
                                            //new CR dont show count
                                        }
                                    </g>
                                </g>
                            </g>
                        </g>
                    </svg>
                );
                break;
        }

        if(icon!=null) return icon;

        if(feelings.memo!=null)
        {
            icon = (
                <svg x={x} y={y} width={width} height="100%" viewBox="0 0 50 50" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-1097.000000, -226.000000)" stroke="#32B5FB">
                            <g id="icon/35px/memo" transform="translate(1097.000000, 226.000000)">
                                <g id="Group-22">
                                    <circle id="Oval-Copy-7" strokeWidth="2" fill="#FFFFFF" fillRule="nonzero" cx="17.8553391" cy="17.5" r="16.5"></circle>
                                    <g id="notepad" transform="translate(10.355339, 10.000000)">
                                        <path d="M0.207479508,1.4609375 L0.207479508,8.4140625 L0.207479508,9.46875 L0.207479508,13 C0.207479508,14.108 1.08000271,15 2.1670082,15 L12.9943648,15 C14.0813702,15 14.9615779,14.108 14.9615779,13 L14.9615779,9.46875 L14.9615779,8.46874998 L14.9615779,1.4609375 L0.207479508,1.4609375 Z" id="Path" strokeWidth="1.5"></path>
                                        <path d="M2.34119066,2.66582325 C1.60671074,2.65950075 1.01332869,2.0839125 1.01332869,1.3748015 C1.01332869,0.661760748 1.61330582,0.0837272502 2.35341443,0.0837272502 C2.96375975,0.0837272502 3.47880394,0.476836 3.64064754,1.014586" id="Path" strokeWidth="1.2" strokeLinecap="round"></path>
                                        <path d="M5.85556033,2.66582325 C5.12107992,2.65950075 4.52769811,2.0839125 4.52769811,1.3748015 C4.52769811,0.661760748 5.127675,0.0837272502 5.8677841,0.0837272502 C6.47812896,0.0837272502 6.9931731,0.476836 7.15501674,1.014586" id="Path" strokeWidth="1.2" strokeLinecap="round"></path>
                                        <path d="M12.8842977,2.66582325 C12.1498178,2.65950075 11.5564357,2.0839125 11.5564357,1.3748015 C11.5564357,0.661760748 12.1564129,0.0837272502 12.8965215,0.0837272502 C13.5068668,0.0837272502 14.021911,0.476836 14.1837546,1.014586" id="Path" strokeWidth="1.2" strokeLinecap="round"></path>
                                        <path d="M9.36992928,2.66582325 C8.63544936,2.65950075 8.0420673,2.0839125 8.0420673,1.3748015 C8.0420673,0.661760748 8.6420442,0.0837272502 9.38215302,0.0837272502 C9.99249834,0.0837272502 10.5075423,0.476836 10.6693861,1.014586" id="Path" strokeWidth="1.2" strokeLinecap="round"></path>
                                        <path d="M2.46776336,5.90205875 L12.6831381,5.90205875" id="Path" strokeLinecap="round"></path>
                                        <path d="M2.4677636,8.90726274 L12.6831381,8.90726274" id="Path" strokeLinecap="round"></path>
                                        <path d="M2.46776336,11.9124665 L12.6831381,11.9124665" id="Path" strokeLinecap="round"></path>
                                    </g>
                                </g>
                                {
                                    // conditionCount>1?(
                                    // <g>
                                    //     <circle cx="32" cy="5" r="10" fill="#3598D4"/>
                                    //     <text x="28" y="9" dy={1} fill="white" style={{fontSize:'14px',color:"white",stroke:"white"}}>{conditionCount}</text>
                                    // </g>
                                    // ):""
                                    //new CR dont show count
                                }
                            </g>
                        </g>
                    </g>
                </svg>
            );

            return icon;
        }

        return icon;
    }

    RenderBpGraphTooltip = (props) => {
        const { active, payload, external, label } = props;

        if (active) {
            const dialogLeftX = props.coordinate.x;
            const currData = external.filter(entry => (entry.day === label))[0];
            const styleTipDown = {
                left: "50px",
            }

            const styleDialog = {
                width: "250px",
                height: "150px",
            }

            const amBpText = (currData.ambp[0] === null ? "--" : currData.ambp[0]) + "/" + (currData.ambp[1] === null ? "--" : currData.ambp[1]);
            const amBpmText = currData.ambpm === null ? "--" : currData.ambpm;
            const pmBpText = (currData.pmbp[0] === null ? "--" : currData.pmbp[0]) + "/" + (currData.pmbp[1] === null ? "--" : currData.pmbp[1]);
            const pmBpmText = currData.pmbpm === null ? "--" : currData.pmbpm;

            return (
                <div className="dialogbox" style={styleDialog}>
                    <div className="body">
                    <span></span>
                    <div>
                        <div style={{paddingLeft:"5px", paddingRight:"5px"}} height={20}>
                            <img src={morningWhite} width={20} height="auto"/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{amBpText} mmHg</span>
                            <img src={bpmWhite} width={18} height="auto" style={{paddingLeft:"7px"}}/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{amBpmText} bpm</span>
                        </div>
                        <hr className="hrWhiteLine"></hr>
                        <div style={{paddingLeft:"5px", paddingRight:"5px"}}>
                            <img src={nightWhite} width={18} height="auto"/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{pmBpText} mmHg</span>
                            <img src={bpmWhite} width={18} height="auto" style={{paddingLeft:"7px"}}/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{pmBpmText} bpm</span>
                        </div>

                    </div>
                    </div>
                </div>
            );
        }

        return null;
    };

    RenderWeightGraphTooltip = (props) => {
        const { active, payload, label } = props;

        // console.log(props);

        if (active) {
            // const currData = external.filter(entry => (entry.day === label))[0];
            if(payload ==null || payload.payload == null) return null;
            const currData = payload[0].payload;

            const styleDialog = {
                width: "150px",
                height: "90px",
            }

            const amWeightText = currData.amweight === null ? "--" : currData.amweight;
            const pmWeightText = currData.pmweight === null ? "--" : currData.pmweight;

            return (
                <div className="dialogbox" style={styleDialog}>
                    <div className="body">
                    <span></span>
                    <div>
                        <div style={{paddingLeft:"5px", paddingRight:"5px"}} height={20}>
                            <img src={morningWhite} width={20} height="auto"/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{amWeightText} kg</span>
                        </div>
                        <hr className="hrWhiteLine"></hr>
                        <div style={{paddingLeft:"5px", paddingRight:"5px"}}>
                            <img src={nightWhite} width={18} height="auto"/>
                            <span style={{paddingLeft:"7px"}} className="tipTextMessage">{pmWeightText} kg</span>
                        </div>

                    </div>
                    </div>
                </div>
            );
        }

        return null;
    };

    renderStepDot = (props) => {
        const {cx, cy, payload} = props;

        if(payload.step == null) return null;
        let icon = null;
        let fixX = 4;

        icon = (
            <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Artboard" transform="translate(-100.000000, -1104.000000)" fill="#FFFFFF" fillRule="nonzero" stroke="#00989E">
                        <g id="icon/special/graph-outline" transform="translate(100.000000, 1104.000000)">
                            <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                        </g>
                    </g>
                </g>
            </svg>
        )
        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    renderBPMDot = (props) => {
        // console.log(props);

        const {cx, cy, payload} = props;

        if(payload.bpm == null) return null;

        let icon = null;
        let fixX = 4;

        // if(props.index/2 == 0)
        // {
        //     fixX = 10;
        // }else{
        //     fixX = -10;
        // }

        if(payload.period == 'am')
        {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-100.000000, -1104.000000)" fill="#FFFFFF" fillRule="nonzero" stroke="#97E1E6">
                            <g id="icon/special/graph-outline" transform="translate(100.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#97E1E6"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }else{
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-127.000000, -1104.000000)" fill="#32B5FB" fillRule="nonzero" stroke="#00989E">
                            <g id="icon/special/graph-filled" transform="translate(127.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };


    renderTEMDot = (props) => {
        // console.log(props);
        const { cx, cy, payload } = props;        
        if (payload.temp == null) return null;
        let icon = null;
        let fixX = 4;        

        if (payload.period == 'am') {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-100.000000, -1104.000000)" fill="#FFFFFF" fillRule="nonzero" stroke="#97E1E6">
                            <g id="icon/special/graph-outline" transform="translate(100.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#97E1E6"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        } else {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-127.000000, -1104.000000)" fill="#32B5FB" fillRule="nonzero" stroke="#00989E">
                            <g id="icon/special/graph-filled" transform="translate(127.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    renderSPO2Dot = (props) => {
        // console.log(props);
        const { cx, cy, payload } = props;
        if (payload.spo2 == null) return null;
        let icon = null;
        let fixX = 4;

        if (payload.period == 'am') {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-100.000000, -1104.000000)" fill="#FFFFFF" fillRule="nonzero" stroke="#97E1E6">
                            <g id="icon/special/graph-outline" transform="translate(100.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#97E1E6"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        } else {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-127.000000, -1104.000000)" fill="#32B5FB" fillRule="nonzero" stroke="#00989E">
                            <g id="icon/special/graph-filled" transform="translate(127.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    renderBGDot = (props) => {
        // console.log(props);
        const { cx, cy, payload } = props;
        if (payload.bg == null) return null;
        let icon = null;
        let fixX = 4;

        if (payload.period == 'am') {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-100.000000, -1104.000000)" fill="#FFFFFF" fillRule="nonzero" stroke="#97E1E6">
                            <g id="icon/special/graph-outline" transform="translate(100.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#97E1E6"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        } else {
            icon = (
                <svg x={cx - fixX} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-127.000000, -1104.000000)" fill="#32B5FB" fillRule="nonzero" stroke="#00989E">
                            <g id="icon/special/graph-filled" transform="translate(127.000000, 1104.000000)">
                                {/*<rect x="0.5" y="0.5" width="6" height="6"></rect>*/}
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    renderWeightMDot = (props) => {
        const {cx, cy, payload, index} = props;

        if(payload.weight == null) return null;

        let icon = null;
        // if(index % 2 == 1)
        // {
        //     this.state.weightDotPositions[parseInt(index / 2)] = props.cx;
        // }

        // if(payload.period == 'am')
        // {
            icon = (
                <svg x={cx - 3} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="Artboard" transform="translate(-154.000000, -1104.000000)" fill="#FFFFFF" stroke="#00989E">
                            <g id="icon/special/graph-circle-outline" transform="translate(154.000000, 1104.000000)">
                                <g id="Oval-Copy">
                                    <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#00989E"></circle>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        // }else{
        //     icon = (
        //         <svg x={cx - 3} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
        //             <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        //                 <g id="Artboard" transform="translate(-181.000000, -1104.000000)" fill="#32B5FB" stroke="#C23579">
        //                     <g id="icon/special/graph-circle-filled" transform="translate(181.000000, 1104.000000)">
        //                         <g id="Oval">
        //                             <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#C23579"></circle>
        //                         </g>
        //                     </g>
        //                 </g>
        //             </g>
        //         </svg>
        //     )
        // }

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    renderWeightMDotPM = (props) => {
        const {cx, cy, payload} = props;

        if(payload.weight_pm == null) return null;

        let icon = null;

        icon = (
            <svg x={cx - 3} y={cy - 4} width="7px" height="7px" viewBox="0 0 7 7" version="1.1" xmlns="http://www.w3.org/2000/svg">
                <g id="Graphic-&amp;-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g id="Artboard" transform="translate(-181.000000, -1104.000000)" fill="#32B5FB" stroke="#C23579">
                        <g id="icon/special/graph-circle-filled" transform="translate(181.000000, 1104.000000)">
                            <g id="Oval">
                                <circle fillRule="nonzero" cx="3.5" cy="3.5" r="3" fill="#C23579"></circle>
                            </g>
                        </g>
                    </g>
                </g>
            </svg>
        )

        return (
            <g key={cx}>
                {icon}
            </g>
        );
    };

    componentDidMount() {
        setTimeout(() => {
            this.addSwipeEvent();
        });

        // this.reloadData();
    }

    componentWillMount(){
        // console.log(FakeData.getFakeData());
        // this.reorganizeFakeData();
        this.reorganizeData();
    }

    addSwipeEvent() {
        var wrapper = document.querySelector('.charts-main');
        // console.log(wrapper);

        if (!document.querySelector('.charts-main')) {
            setTimeout(() => {
                this.addSwipeEvent();
            }, 500);
            return;
        }
        this.hideTips();
        this.hammerManager = new Hammer.Manager(document.querySelector('.charts-main'));

        let Swipe = new Hammer.Swipe({ direction: Hammer.DIRECTION_HORIZONTAL });
        this.hammerManager.add(Swipe);

        this.hammerManager.on('swipeleft swiperight', (e) => {
            e.preventDefault();
            const { type } = e;

            if (this.state.isLoading) {
                return;
            }
            // const dateFmt = this.mode === MODE_TYPE.WEEKS ? 'weeks' : 'days';
            switch (type) {
                case 'swipeleft':
                    this.nextPage();
                    break;
                case 'swiperight':
                    this.prePage();
                    break;
                default:
                    break;
            }
        });
    }

    handleBPBarClick = (data, index, e) => {
        console.group('handleBPBarClick');
        console.log(data);
        console.log(index);
        console.groupEnd('handleBPBarClick');
        if(isNaN(index))
        {
            this.showTips(data, null);
        }else{
            this.showTips(data, index);
        }
    };

    showTips(data, activeTooltipIndex)
    {
        if(data == null) return this.hideTips();
        let date = null;
        if(data.activeLabel !== undefined){
            date = this.formatDate(data.activeLabel);
        }else if(data.day !== undefined){
            date = this.formatDate(data.day);
        }

        if(this.state.clickCalendar !== '' && this.state.clickCalendar !== date){
            let _date = this.state.clickCalendar;
            let text1 = document.getElementById("calendar_" + _date).getElementsByTagName("text")[0];
            let text2 = document.getElementById("calendar_" + _date).getElementsByTagName("text")[1];
            text1.setAttribute('fill','#8D8D8D');
            text2.setAttribute('fill','#8D8D8D');
        }
        this.setState({
            clickCalendar:date
        });

        let text1 = document.getElementById("calendar_" + date).getElementsByTagName("text")[0];
        let text2 = document.getElementById("calendar_" + date).getElementsByTagName("text")[1];
        text1.setAttribute('fill','#C23579');
        text2.setAttribute('fill','#ffffff');

        let tooltipIndex = 0;
        let dataType = null;
        if(activeTooltipIndex == null)
        {
            tooltipIndex = data.activeTooltipIndex;
            if(data.activePayload!=null)
            {
                dataType = data.activePayload[0].payload.type;
            }
        }else{
            tooltipIndex = activeTooltipIndex;
            dataType = data.type;
        }
        
        let index = 0;
        //period index, Caculate am,pm index
        let pIndex = 0;
        let period = null;
        
        if (['BPM', 'TEMP', 'BG', 'SPO2'].includes(dataType)) 
        {
            index = parseInt(tooltipIndex/2);
            pIndex = tooltipIndex;

            period = data.activePayload[0].payload.period;
        }else{
            index = tooltipIndex;
            pIndex = index * 2;
        }

        if(this.lastSelectedIndex == index)
        {
            this.hideTips();
            this.lastSelectedIndex = -1;
            return;
        }

        this.lastSelectedIndex = index;

        // if(index+1>this.state.data.length || )

        let x = 0;

        if(data.activeCoordinate != null)
        {
            x = data.activeCoordinate.x;
        }else{
            x = data.cx;
        }

        // console.group("showTips");
        // console.log(document.getElementById("chartWeight").offsetTop);
        // console.groupEnd();

        let divMaskWidth = document.getElementById("divMask").offsetWidth;
        let divToolTipBPWidth = document.getElementById("divToolTipBP").offsetWidth;
        let divToolTipWeightWidth = document.getElementById("divToolTipWeight").offsetWidth;
        let divToolTipTempWidth = document.getElementById("divToolTipTemp").offsetWidth;
        let divToolTipBgWidth = document.getElementById("divToolTipBg").offsetWidth;
        let divToolTipSpo2Width = document.getElementById("divToolTipSpo2").offsetWidth;

        let divToolTipStepWidth = document.getElementById("divToolTipStep").offsetWidth;

        let maskBarX = x;
        maskBarX = Math.round(this.state.maskBarPositions[index])  - divMaskWidth/3.0;
        console.log(this.state.maskBarPositions[index], divMaskWidth, divMaskWidth/3.0, maskBarX);

        let arrowX = maskBarX + divMaskWidth/2 - 10;
        let maskBarCircleX = this.state.maskBarPositions[index] - 15;

        let ambp = "--";
        let pmbp = "--";
        let ambpm = "--";
        let pmbpm = "--";
        let amweight = "--";
        let pmweight = "--";
        let step = "--";
        let sleeptime = "--";
        let wakeuptime = "--";
        let duration = "--";

        let amTemp = "--";
        let pmTemp = "--";
        let ambg = "--";
        let pmbg = "--";
        let amspo2 = "--";
        let pmspo2 = "--";

    
        ambp = this.state.data[index].ambp[0] == null ? "--/--" : this.state.data[index].ambp[0] + "/" + this.state.data[index].ambp[1];
        pmbp = this.state.data[index].pmbp[0] == null ? "--/--" : this.state.data[index].pmbp[0] + "/" + this.state.data[index].pmbp[1];
        amweight = this.state.dataWeight[index].weight_am == null ? "--" : this.state.dataWeight[index].weight_am;
        pmweight = this.state.dataWeight[index].weight_pm == null ? "--" : this.state.dataWeight[index].weight_pm;        
        
        sleeptime =  this.state.dataSleep[index].sleepTime == null ? "--" : this.formatAMPM(this.state.dataSleep[index].sleepTime);
        wakeuptime =  this.state.dataSleep[index].wakeUpTime == null ? "--" : this.formatAMPM(this.state.dataSleep[index].wakeUpTime);
        duration =  this.state.dataSleep[index].duration == null ? "--" : this.getHoursMinute(this.state.dataSleep[index].duration);
        
        if(period == null || period == "am")
        {
            ambpm = this.state.dataBPM[pIndex].bpm == null ? "--" : this.state.dataBPM[pIndex].bpm;
            pmbpm = this.state.dataBPM[pIndex+1].bpm == null ? "--" : this.state.dataBPM[pIndex+1].bpm;
            
            amTemp = this.state.dataTemperature[pIndex].temp == null ? "--" : this.state.dataTemperature[pIndex].temp;
            pmTemp = this.state.dataTemperature[pIndex + 1].temp == null ? "--" : this.state.dataTemperature[pIndex+1].temp;

            ambg = this.state.dataBG[pIndex].bg == null ? "--" : this.state.dataBG[pIndex].bg;
            pmbg = this.state.dataBG[pIndex + 1].bg == null ? "--" : this.state.dataBG[pIndex + 1].bg;

            amspo2 = this.state.dataSpo2[pIndex].spo2 == null ? "--" : this.state.dataSpo2[pIndex].spo2;
            pmspo2 = this.state.dataSpo2[pIndex + 1].spo2 == null ? "--" : this.state.dataSpo2[pIndex + 1].spo2;

        }else if(period == "pm"){
            ambpm = this.state.dataBPM[pIndex-1].bpm == null ? "--" : this.state.dataBPM[pIndex-1].bpm;
            pmbpm = this.state.dataBPM[pIndex].bpm == null ? "--" : this.state.dataBPM[pIndex].bpm;

            amTemp = this.state.dataTemperature[pIndex -1].temp == null ? "--" : this.state.dataTemperature[pIndex -1].temp;
            pmTemp = this.state.dataTemperature[pIndex].temp == null ? "--" : this.state.dataTemperature[pIndex ].temp;

            ambg = this.state.dataBG[pIndex - 1].bg == null ? "--" : this.state.dataBG[pIndex -1].bg;
            pmbg = this.state.dataBG[pIndex].bg == null ? "--" : this.state.dataBG[pIndex].bg;

            amspo2 = this.state.dataSpo2[pIndex - 1].spo2 == null ? "--" : this.state.dataSpo2[pIndex - 1].spo2;
            pmspo2 = this.state.dataSpo2[pIndex].spo2 == null ? "--" : this.state.dataSpo2[pIndex].spo2;
        }

        step = this.state.dataStep[index].step == null ? "--" : this.state.dataStep[index].step;

        let tipBoxBPX = this.state.maskBarPositions[index];
        let tipBoxBPArrowX = x - 5;
        let tipBoxWeightX = -9999;
        let tipBoxStepX = -9999;
        let tipBoxSleepX = -9999;
        let tipBoxTempX = -9999;
        let tipBoxBGX = -9999;
        let tipBoxSpo2X = -9999;
        

        if(tipBoxBPX + divToolTipBPWidth >= window.innerWidth)
        {
            tipBoxBPX -= (tipBoxBPX + divToolTipBPWidth) - window.innerWidth;
        }

        if(tipBoxBPX + 50 >= tipBoxBPArrowX) tipBoxBPX -= 45;

        tipBoxWeightX = this.state.maskBarPositions[index];
        let tipBoxWeightArrowX = this.state.weightDotPositions[index] - 9;
        if(tipBoxWeightX + divToolTipWeightWidth >= window.innerWidth)
        {
            tipBoxWeightX -= (tipBoxWeightX + divToolTipWeightWidth) - window.innerWidth - 0;
        }else{
            if(tipBoxWeightX + 50 >= tipBoxWeightArrowX) tipBoxWeightX -= 45;
        }

        tipBoxTempX = this.state.maskBarPositions[index];
        let tipBoxTempArrowX = this.state.temperaturePositions[index] - 9;
        if (tipBoxTempX + divToolTipTempWidth >= window.innerWidth) {
            tipBoxTempX -= (tipBoxTempX + divToolTipTempWidth) - window.innerWidth - 0;
        } else {
            if (tipBoxTempX + 50 >= tipBoxTempArrowX) tipBoxTempX -= 45;
        }

        tipBoxBGX = this.state.maskBarPositions[index];
        let tipBoxBGArrowX = this.state.bgPositions[index] - 9;
        if (tipBoxBGX + divToolTipBgWidth >= window.innerWidth) {
            tipBoxBGX -= (tipBoxBGX + divToolTipBgWidth) - window.innerWidth - 0;
        } else {
            if (tipBoxBGX + 50 >= tipBoxBGArrowX) tipBoxBGX -= 45;
        }


        tipBoxSpo2X = this.state.maskBarPositions[index];
        let tipBoxSpo2ArrowX = this.state.spo2Positions[index] - 9;
        if (tipBoxSpo2X + divToolTipSpo2Width >= window.innerWidth) {
            tipBoxSpo2X -= (tipBoxSpo2X + divToolTipSpo2Width) - window.innerWidth - 0;
        } else {
            if (tipBoxSpo2X + 50 >= tipBoxSpo2ArrowX) tipBoxSpo2X -= 45;
        }

        tipBoxStepX = this.state.maskBarPositions[index];
        let tipBoxStepArrowX = this.state.stepDotPositions[index] - 9;
        if(tipBoxStepX + divToolTipStepWidth >= window.innerWidth)
        {
            tipBoxStepX -= (tipBoxStepX + divToolTipStepWidth) - window.innerWidth - 0;
        }else{
            if(tipBoxStepX + 50 >= tipBoxStepArrowX) tipBoxStepX -= 45;
        }

        tipBoxSleepX = this.state.maskBarPositions[index];
        let tipBoxSleepArrowX = this.state.stepDotPositions[index] - 9;
        if(tipBoxSleepX + divToolTipStepWidth >= window.innerWidth)
        {
            tipBoxSleepX -= (tipBoxSleepX + divToolTipStepWidth) - window.innerWidth - 0;
        }else{
            if(tipBoxSleepX + 50 >= tipBoxSleepArrowX) tipBoxSleepX -= 45;
        }

        let feelings = this.state.data[index].feelings;
        let conditionCount = this.getConditionCount(feelings);
        let tipBoxConditionX = -9999;
        let tipBoxConditionWidth = 0;
        let tipBoxConditionContent = (<div></div>);
        let tipBoxConditionIcons = [];

        let tipBoxConditionArrowX = -9999;
        let tipBoxConditionArrowX2 = -9999;
        if(conditionCount > 1)
        {
            tipBoxConditionArrowX = this.state.conditionIconPositions[index] + 5.5;
            tipBoxConditionArrowX = arrowX;
            tipBoxConditionArrowX2 = arrowX;
            tipBoxConditionX = arrowX;
            tipBoxConditionWidth = conditionCount * 27;
            if(conditionCount<5)
            {
                tipBoxConditionWidth += 5;
            }
            if((tipBoxConditionX + tipBoxConditionWidth) + 20 >= window.innerWidth)
            {
                tipBoxConditionX -= (tipBoxConditionX + tipBoxConditionWidth) - window.innerWidth + 25;
            }

            tipBoxConditionIcons.push(iconFaces[feelings.feeling - 1]);
            if(feelings.conditions!=null && false) // new CR don't show conditions
            {
                for(var iconIndex in feelings.conditions)
                {
                    tipBoxConditionIcons.push(iconConditions[feelings.conditions[iconIndex] - 1]);
                }
            }

            if(feelings.memo!=null)
            {
                tipBoxConditionIcons.push(iconMemo);
            }

            let zIndex=9998;
            let i = 0;
            tipBoxConditionContent = "<div>";
            for(var iconIndex in tipBoxConditionIcons)
            {
                tipBoxConditionContent += '<div style="position:absolute; left:' + (i * 25) +'px; z-index:' + zIndex + '">';
                tipBoxConditionContent += '<img src="' + tipBoxConditionIcons[iconIndex] + '" width="35px" height="auto"/>';
                tipBoxConditionContent += "</div>";

                zIndex--;i++;
            }
            // tipBoxConditionContent = (
            //     for(var icon in tipBoxConditionIcons)
            //     {
            //         <div style={{position:"absolute", left:0, zIndex:{i}}}>
            //             <img src={icon} width={35} height="auto"/>
            //         </div>
            //     }
            // );
        }

        if(tipBoxConditionX + 0 >= tipBoxConditionArrowX)
        {
            tipBoxConditionX -= 35;
        }

        let medicationDisplayCount = 0;

        medicationDisplayCount += this.state.medicationDisplay.morning=="block" ? 1 : 0;
        medicationDisplayCount += this.state.medicationDisplay.noon=="block" ? 1 : 0;
        medicationDisplayCount += this.state.medicationDisplay.evening=="block" ? 1 : 0;

        let tipBoxBPArrowY = "0%";
        let tipBoxWeightArrowY = "0%";
        let tipBoxTempArrowY = "0%";
        let tipBoxBGArrowY = "0%";
        let tipBoxSpo2ArrowY = "0%";
        let tipBoxConditionArrowY = "0%";
        let tipBoxStepArrowY = "0%";
        let tipBoxSleepArrowY = "0%";

        

        if(medicationDisplayCount==3)
        {
            tipBoxBPArrowY = "14%";
        }else if(medicationDisplayCount==2){
            tipBoxBPArrowY = "14.7%";
        }else if(medicationDisplayCount==1){
            tipBoxBPArrowY = "15.5%";
        }else{
            tipBoxBPArrowY = "16.2%";
        }

        let tipBoxWeightY = document.getElementById("chartWeight").offsetTop - 100;
        tipBoxWeightArrowY = tipBoxWeightY + 100;

        let tipBoxTempY = document.getElementById("chartTemp").offsetTop - 103;
        tipBoxTempArrowY = tipBoxTempY + 100;

        let tipBoxBGY = document.getElementById("chartBg").offsetTop - 103;
        tipBoxBGArrowY = tipBoxBGY + 100;
           
        let tipBoxSpo2Y = document.getElementById("chartSpo2").offsetTop - 103;
        tipBoxSpo2ArrowY = tipBoxSpo2Y + 100;
    
        let tipBoxStepY = document.getElementById("chartStep").offsetTop - 65;
        tipBoxStepArrowY = tipBoxStepY + 60;

        let tipBoxSleepY = document.getElementById("chartSleep").offsetTop - 125;
        tipBoxSleepArrowY = tipBoxSleepY + 120;

        let tipBoxConditionY = document.getElementById("chartCondition").offsetTop - 80;
        tipBoxConditionArrowY = tipBoxConditionY + 80;

        let tipBoxBPY = document.getElementById("chartBP").offsetTop - 110;
        tipBoxBPArrowY = tipBoxBPY + 104;
        this.setState({
            maskBar: {
                x: maskBarX,
                y: 70
            },
            maskBarCircle: {
                x: maskBarCircleX
            },
            curBPData: {
                ambp: ambp,
                pmbp: pmbp
            },
            curStepData: {
                step: step,
            },
            curSleepData:{
                sleep_time:sleeptime,
                wake_up_time:wakeuptime,
                duration:duration
            },
            tipBoxStep: {
                x: tipBoxStepX,
                y: tipBoxStepY,
                arrowX: arrowX,
                arrowY: tipBoxStepArrowY
            },
            tipBoxSleep: {
                x: tipBoxSleepX,
                y: tipBoxSleepY,
                arrowX: arrowX,
                arrowY: tipBoxSleepArrowY
            },
            tipBoxBP: {
                x: tipBoxBPX,
                y: tipBoxBPY,
                arrowX: arrowX,
                arrowY: tipBoxBPArrowY
            },
            tipBoxWeight: {
                x: tipBoxWeightX,
                y: tipBoxWeightY,
                arrowX: arrowX,
                arrowY: tipBoxWeightArrowY
                // arrowX: tipBoxWeightArrowX
            },
            tipBoxTemperature: {
                x: tipBoxTempX,
                y: tipBoxTempY,
                arrowX: arrowX,
                arrowY: tipBoxTempArrowY,
            },
            tipBoxBG: {
                x: tipBoxBGX,
                y: tipBoxBGY,
                arrowX: arrowX,
                arrowY: tipBoxBGArrowY,
            },
            tipBoxSpo2: {
                x: tipBoxSpo2X,
                y: tipBoxSpo2Y,
                arrowX: arrowX,
                arrowY: tipBoxSpo2ArrowY,
            },
            tipBoxCondition:{
                x: tipBoxConditionX,
                y:tipBoxConditionY,
                // arrowX: tipBoxConditionArrowX,
                arrowX:tipBoxConditionArrowX2,
                arrowY: tipBoxConditionArrowY,
                width: tipBoxConditionWidth,
                content: tipBoxConditionContent
            },
            curBPMData: {
                ambpm: ambpm,
                pmbpm: pmbpm
            },
            curWeightData: {
                amweight: amweight,
                pmweight: pmweight
            },
            curTemperatureData: {
                amTemp: amTemp,
                pmTemp: pmTemp
            },
            curBGData: {
                ambg: ambg,
                pmbg: pmbg
            },
            curSpo2Data: {
                amspo2: amspo2,
                pmspo2: pmspo2
            },

        });

    }

    hideTips()
    {
        this.setState({
            maskBar: {
                x: -9999,
                y: 70
            },
            maskBarCircle: {
                x: -9999,
            },
            tipBoxBP: {
                x: -9999,
                arrowX: -9999
            },
            tipBoxWeight: {
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxTemperature:{
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxBG:{
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxSpo2: {
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxStep: {
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxSleep: {
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999
            },
            tipBoxCondition:{
                x: -9999,
                y: -9999,
                arrowX: -9999,
                arrowY: -9999,
                width: 0,
                content: (<div></div>)
            }
        });
        let date = this.state.clickCalendar;
        if(date){

            if(document.getElementById("calendar_" + date)){
                let text1 = document.getElementById("calendar_" + date).getElementsByTagName("text")[0];
                let text2 = document.getElementById("calendar_" + date).getElementsByTagName("text")[1];
                text1.setAttribute('fill','#8D8D8D');
                text2.setAttribute('fill','#8D8D8D');
            }

            this.setState({
                clickCalendar:''
            })
        }
    }

    clickedCalendar(isClick){
        let date =  this.state.clickCalendar;
        // console.log(document.getElementById("calendar_" + date).getElementsByTagName("text"));
        // let text1 = document.getElementById("calendar_" + date).getElementsByTagName("text")[0];
        // console.log(text1);
        // let text2 = document.getElementById("calendar_" + date).getElementsByTagName("text")[1];
        //
        // if(isClick){
        //     text1.setAttribute('fill','#C23579');
        //     text2.setAttribute('fill','#ffffff');
        // }else{
        //     text1.setAttribute('fill','#8D8D8D');
        //     text2.setAttribute('fill','#8D8D8D');
        // }
    }

    getBPYAxisTicks(data, count, decimals, offset)
    {
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].ambp[0]!=null)
            {
                arr.push(data[i].ambp[0]);
            }
            if(data[i].ambp[1]!=null)
            {
                arr.push(data[i].ambp[1]);
            }
            if(data[i].pmbp[0]!=null)
            {
                arr.push(data[i].pmbp[0]);
            }
            if(data[i].pmbp[1]!=null)
            {
                arr.push(data[i].pmbp[1]);
            }
        }

        let min = this.state.diaGoal ? this.state.diaGoal : 0;
        let max = this.state.sysGoal ? this.state.sysGoal : 100;
        
        if(arr.length>0)
        {
            let _arr = [...arr, min, max]
            min = Math.min.apply(null, _arr);
            max = Math.max.apply(null, _arr);
        }

        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getBPMYAxisTicks(data, count, decimals, offset)
    {
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].bpm!=null)
            {
                arr.push(data[i].bpm);
            }
        }

        let min = 0;
        let max = 100;

        if(arr.length>0)
        {
            let _arr = [...arr, min, max]
            min = Math.min.apply(null, _arr);
            max = Math.max.apply(null, _arr);
        }

        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getTEMPYAxisTicks(data, count, decimals, offset){
        if (data == null) return { interval: 0, ticks: [0] };

        let arr = [];

        for (var i = 0; i < data.length; i++) {
            if (data[i].temp != null) {
                arr.push(data[i].temp);
            }
        }

        let min = 0;
        let max = 100;

        if (arr.length > 0) {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }
        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getSPO2YAxisTicks(data, count, decimals, offset){
        if (data == null) return { interval: 0, ticks: [0] };
        let arr = [];

        for (var i = 0; i < data.length; i++) {
            if (data[i].spo2 != null) {
                arr.push(data[i].spo2);
            }
        }

        let min = 0;
        let max = 100;

        if (arr.length > 0) {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }
        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getBGYAxisTicks(data, count, decimals, offset){
        if (data == null) return { interval: 0, ticks: [0] };
        let arr = [];

        for (var i = 0; i < data.length; i++) {
            if (data[i].bg != null) {
                arr.push(data[i].bg);
            }
        }

        let min = 0;
        let max = 100;

        if (arr.length > 0) {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }
        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getWeightYAxisTicks(data, count, decimals, offset)
    {
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].weight!=null)
            {
                arr.push(data[i].weight);
            }
        }

        if(this.fullData.mewc!=null)
        {
            arr.push(this.fullData.mewc.startWeight);
            arr.push(this.fullData.mewc.goalWeight);
        }

        let min = 0;
        let max = this.state.weightLGoal ? this.state.weightLGoal : 100;
        let omin;
        let omax;
        if(arr.length>0)
        {
            // min = Math.min.apply(null, arr);
            // max = Math.max.apply(null, arr);

            omin = Math.min.apply(null, arr);
            omax = Math.max.apply(null, arr);

            console.log(arr)
            console.log(omax)

            if(omin<=this.state.weightLGoal){
                min=this.state.weightLGoal
            }else{
                min=omin
            }

            if(omax<=this.state.weightHGoal){
                max=this.state.weightHGoal
            }else{
                max=omax
            }

        }
        // console.group("getWeightYAxisTicks");
        // console.log(min, max, arr, this.fullData.mewc);
        // console.groupEnd();

        console.log(this.state.weightLGoal)
        console.log(max)

        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getStepYAxisTicks(data, count, decimals, offset){
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].step!=null)
            {
                arr.push(data[i].step);
            }
        }

        if(this.state.stepGoal !== null){
            arr.push(this.state.stepGoal);
        }

        let min = 0;
        let max = 100;
        if(arr.length>0)
        {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }

        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getStepYAxisTicks(data, count, decimals, offset){
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].step!=null)
            {
                arr.push(data[i].step);
            }
        }

        if(this.state.stepGoal !== null){
            arr.push(this.state.stepGoal);
        }

        let min = 0;
        let max = 100;
        if(arr.length>0)
        {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }

        return this.getYAxisTicks(min, max, count, decimals, offset);
    }

    getYAxisTicks(min, max, count, decimals, offset)
    {
        let result = {interval:0, ticks:[0]};
        if(min>max) return result;

        if(min==max && max>0)
        {
            min=max-3;
        }

        min-=offset;
        max+=offset;

        if(min<0) min = 0;

        var interval = (max - min) / (count+1);
        if(decimals == 0)
        {
            interval = parseInt(interval);
        }else{
            interval = parseFloat(interval).toFixed(decimals);
        }

        result = [];
        result.push(min);
        for(var i=0;i<count;i++)
        {
            result.push(min+interval*(i+1));
        }
        result.push(min+interval*(count+1));

        if(decimals>0)
        {
            for(var i=0;i<result.length;i++)
            {
                // let weightStr = parseFloat(result[i]).toFixed(decimals);
                // if(weightStr.indexOf(".")<0)
                // {
                //     weightStr+=".0";
                // }
                // result[i] = weightStr;
                // result[i] = parseFloat(weightStr);
                result[i] = parseFloat(parseFloat(result[i]).toFixed(decimals));
            }
        }

        result = {interval:interval, ticks:result};

        return result;
    }

    renderBPMXAxisTick = (props) => {
        return null;
    }

    reorganizeFakeData()
    {
        this.fullData = FakeData.getFakeData2();
        this.state.medicationDisplay = {morning:"block", noon:"block", evening:"block"};
        this.initData();
        this.reloadData();
    }

    nextMonth () {
        let toDate = moment(new Date()).format('YYYY-MM-DD') + " 23:59:59";
        if(this.state.toDate == toDate)
        {
            console.log("Today is last date");
            return;
        }

        // let curToDate = new Date(this.state.toDate);

        toDate = this.convertToDate(this.state.toDate);
        toDate.setDate(toDate.getDate() + 30);
        let fromDate = this.convertToDate(this.state.toDate);
        fromDate.setDate(fromDate.getDate() + 1);

        this.state.fromDate = moment(fromDate).format('YYYY-MM-DD' + " 00:00:00");
        this.state.toDate = moment(toDate).format('YYYY-MM-DD' + " 23:59:59");

        this.dataMonthDirection = "next";
        this.reorganizeData();
    }

    preMonth() {
        let toDate = this.convertToDate(this.state.fromDate);
        toDate.setDate(toDate.getDate() - 1);

        let fromDate = this.convertToDate(this.state.fromDate);
        fromDate.setDate(fromDate.getDate() - 30);

        this.state.fromDate = moment(fromDate).format('YYYY-MM-DD' + " 00:00:00");
        this.state.toDate = moment(toDate).format('YYYY-MM-DD' + " 23:59:59");

        this.dataMonthDirection = "pre";
        this.reorganizeData();
    }

    generateMEWCGoalData(dataWeight)
    {
        if(dataWeight == null) return;
        let dataMEWCWeight = [];
        let dayCount = 1;
        let avgWeight = 0;
        var i = 0;
        var n=0;
        let day = "";
        let date = null;
        let weightMEWC = 0;
        let check = null;

        // console.log(this.fullData.mewc);
        if(this.fullData.mewc!=null)
        {
            dayCount = moment(this.fullData.mewc.endDate,"YYYY-MM-DD").diff(moment(this.fullData.mewc.startDate,"YYYY-MM-DD"), 'days');
            // console.group("generateMEWCGoalData");
            // console.log(moment(this.fullData.mewc.startDate,"YYYY-MM-DD"));
            // console.log(moment(this.fullData.mewc.endDate,"YYYY-MM-DD"));
            // console.log(moment(this.fullData.mewc.endDate,"YYYY-MM-DD").diff(moment(this.fullData.mewc.startDate,"YYYY-MM-DD"), 'days'));
            // console.groupEnd();
            const t = dayCount*2;
            avgWeight = (this.fullData.mewc.startWeight - this.fullData.mewc.goalWeight) / t;
            date = this.convertToDate(this.fullData.mewc.startDate);

            n=0;
            for(i=0;i<t;i++)
            {
                if(i%2==0)
                {
                    day = moment(date).format('YYYY-MM-DD') + " 09:00:00";
                    // check = null;
                }else{
                    day = moment(date).format( 'YYYY-MM-DD') + " 14:00:00";
                    date.setDate(date.getDate() + 1);
                    // check = this.fullData.mewc.ticks[n].check;
                    // console.log(day, this.fullData.mewc.ticks[n], check);
                    n++;
                }
                check = this.fullData.mewc.ticks[n].check;
                weightMEWC = this.fullData.mewc.startWeight - (avgWeight * i);
                if(i+1==t)
                {
                    weightMEWC = this.fullData.mewc.goalWeight;
                }

                dataMEWCWeight.push(
                    {
                        day:day,
                        weightMEWC: weightMEWC,
                        check:check
                    }
                )
            }
        }


        // weightMEWC
        for(i=0;i<dataWeight.length;i++)
        {

            let stempDate = dataWeight[i].day.length == 10 ? dataWeight[i].day + ' 09:00:00' : dataWeight[i].day;
            let item = dataMEWCWeight.filter(entry => (entry.day === stempDate));
            if(item[0]!=undefined)
            {
                dataWeight[i].weightMEWC = item[0].weightMEWC;
                dataWeight[i].checkMEWC = item[0].check;
            }else{
                dataWeight[i].weightMEWC = null;
                dataWeight[i].checkMEWC = null;
            }
        }

        return dataWeight;
    }

    async reorganizeData()
    {
        // console.log(this.state.fromDate, this.state.toDate);
        this.$f7.dialog.preloader();
        let data = await GraphService.getMeasureDataEveryday(this.state.fromDate,this.state.toDate);
        // this.reorganizeBPData(bpData);
        // this.reorganizeMedicationData(await GraphService.getMedication(this.state.fromDate,this.state.toDate));
        // this.reorganizeConditionData(await GraphService.getCondition(this.state.fromDate,this.state.toDate));
        // this.reorganizeStepData(await GraphService.getStep(this.state.fromDate,this.state.toDate));
        // this.reorganizeSleepData(await GraphService.getSleep(this.state.fromDate,this.state.toDate));
        // this.reorganizeMEWCData(await GraphService.getMEWC());
        // this.reorganizeGoalSysDiaData(await GraphService.getGoalSysDia());
        // this.reorganizeTemperatureData(await GraphService.getTemperatureData(this.state.fromDate, this.state.toDate));
        // this.reorganizeBGData(await GraphService.getBloodGlucose(this.state.fromDate, this.state.toDate));
        // this.reorganizeSpo2Data(await GraphService.getSpo2(this.state.fromDate, this.state.toDate));
        // this.getAllGoal(await GraphService.getGoal())

        this.reorganizeBPData(data.user_measure_data);
        this.reorganizeMedicationData(data.user_medication);
        this.reorganizeConditionData(data.user_condition);
        this.reorganizeStepData(data.step);
        this.reorganizeSleepData(data.sleep);
        this.reorganizeMEWCData(data.current_mewc);
        this.reorganizeGoalSysDiaData(data.user_info);
        this.reorganizeTemperatureData(data.user_temperature);
        this.reorganizeBGData(data.user_blood_glucose);
        this.reorganizeSpo2Data(data.user_spo2);
        this.getAllGoal(data.user_goal)

        this.initData();
        this.reloadData();
        this.$f7.dialog.close();
    }

    async reorganizeBf7daysData(startDate,endDate){
        this.$f7.dialog.preloader();

        let data = await GraphService.getMeasureDataEveryday(this.state.fromDate,this.state.toDate);

        let bf7daysBpData = data.user_measure_data;
        let bf7daysConditionData = data.user_condition;
        let bf7daysStepData = data.step;
        let bf7daysSleepData = data.sleep;
        let bf7daysBgData = data.user_blood_glucose;
        let bf7daysSpo2Data = data.user_spo2;

        // let bf7daysBpData = await GraphService.getMeasureDataEveryday(startDate,endDate);
        // let bf7daysConditionData = await GraphService.getCondition(startDate,endDate);
        // let bf7daysStepData = await GraphService.getStep(startDate,endDate);
        // let bf7daysSleepData = await GraphService.getSleep(startDate,endDate);
        // let bf7daysBgData = await GraphService.getBloodGlucose(startDate, endDate);
        // let bf7daysSpo2Data = await GraphService.getSpo2(startDate, endDate);

        let stepDiff = 0;
        let sleepDiff = 0;
        let feelingDiff = 0;
        let weightDiff = 0;
        let bgDiff = 0
        let spo2Diff = 0
        
        if(bf7daysStepData !== undefined){
            stepDiff = bf7daysStepData.diff;
        }
        if(bf7daysSleepData.diff !== undefined){
            sleepDiff = bf7daysSleepData.diff
        }

        if(bf7daysConditionData.diff !== undefined){
            feelingDiff = bf7daysConditionData.diff;
        }
        
        if(bf7daysBpData.weight_diff !== undefined){
            weightDiff = bf7daysBpData.weight_diff;
        }

        if (bf7daysBgData.diff !== undefined) {
            bgDiff = bf7daysBgData.diff;
        }

        if (bf7daysSpo2Data.diff !== undefined) {
            spo2Diff = bf7daysSpo2Data.diff;
        }
        this.setState({
            dataDiff:{
                step:stepDiff,
                sleep:sleepDiff,
                feeling:feelingDiff,
                weight:weightDiff,
                bg: bgDiff,
                spo2: spo2Diff
            }
        });
        // console.log(this.state.dataDiff);
        this.$f7.dialog.close();
    }

    reorganizeMEWCData(data)
    {
        if(data==null || data.length==0) return;
        console.group("reorganizeMEWCData");

        data.startDate = moment(data.startDate).format("YYYY-MM-DD");
        data.endDate = moment(data.endDate).format("YYYY-MM-DD");        
        if(moment().diff(moment(data.endDate), 'second') > 1){
            return;
        }
        data.startWeight = parseFloat(data.startWeight);
        data.goalWeight = parseFloat(data.goalWeight);
        for(var i=0;i<data.ticks.length;i++)
        {
            data.ticks[i].day = moment(data.ticks[i].day).format("YYYY-MM-DD");
            if(data.ticks[i].check==true)
            {
                data.ticks[i].check = 1;
            }else{
                data.ticks[i].check = null;
            }
            // data.ticks[i].check = 1;
        }

        console.log(data);
        console.groupEnd();

        this.fullData.mewc = data;
    }

    reorganizeConditionData(data)
    {
        // console.log(data);
        let conditionData = [];
        if(data!=null)
        {
            conditionData = data.conditionList !== undefined ? data.conditionList : null;
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        let i=0;

        while(fromDate<=toDate)
        {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let items = conditionData.filter(entry => (entry.date === dateKey));
            //conditions 1:Dry Cough 2:Migraine 3:Dizziness 4:Heart Palpitations 5:Hot Flashes 6:Swelling
            // feelings:{feeling:5, conditions:[1,2,3,4,5,6], memo:1}
            let feelings = {feeling:null, conditions:[], memo:null};

            items.forEach(element => {
                feelings.feeling = parseInt(element.mood);
                feelings.memo = element.memo == "1" ? 1 : null;

                if(element.dry_cough=="1") feelings.conditions.push(1);
                if(element.migraine=="1") feelings.conditions.push(2);
                if(element.dizziness=="1") feelings.conditions.push(3);
                if(element.heart_palpitations=="1") feelings.conditions.push(4);
                if(element.hot_flashes=="1") feelings.conditions.push(5);
                if(element.swelling=="1") feelings.conditions.push(6);
            });

            this.fullData.main[i].feelings = feelings;
            fromDate.setDate(fromDate.getDate() + 1);
            i++;
        }
    }

    reorganizeMedicationData(data)
    {

        console.log(data)

        let medicationData = [];
        let reminderData = {};
        if( data &&data.result!=null)
        {
            medicationData =data.result;
        }
        if (data && data.reminder!=null)
        {
            reminderData = data.reminder;
        }

        let _morning = reminderData.morning != undefined ? "block" : "none";
        let _noon = reminderData.noon != undefined ? "block" : "none";
        let _evening = reminderData.evening != undefined ? "block" : "none";

        let medicationDisplay = {morning:_morning, noon:_noon, evening: _evening};
        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));

        let i=0;

        while(fromDate<=toDate)
        {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let items = medicationData.filter(entry => (entry.date === dateKey));
            let ammc = null;
            let nnmc = null;
            let pmmc = null;

            items.forEach(element => {
                if(element.type == 'Morning')
                {
                    ammc = element.status == "1" ? 1 : null;
                }
                if(element.type == 'Noon')
                {
                    nnmc = element.status == "1" ? 1 : null;
                }
                if(element.type == 'Evening')
                {
                    pmmc = element.status == "1" ? 1 : null;
                }
            });

            // if(medicationDisplay.morning=="none" && ammc !=null) medicationDisplay.morning="block";
            // if(medicationDisplay.noon=="none" && nnmc !=null) medicationDisplay.noon="block";
            // if(medicationDisplay.evening=="none" && pmmc !=null) medicationDisplay.evening="block";

            this.fullData.main[i].ammc = ammc;
            this.fullData.main[i].nnmc = nnmc;
            this.fullData.main[i].pmmc = pmmc;
            fromDate.setDate(fromDate.getDate() + 1);
            i++;
        }

        this.state.medicationDisplay = medicationDisplay;
        // console.log("========================================");
        // console.log(this.state.medicationDisplay);
        // console.log("========================================");
    }

    reorganizeBPData(data)
    {
        console.log(data);
        let bpData = [];
        if(data!=null)
        {
            bpData = data.measureDataList !== undefined ? data.measureDataList : null;
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.bpm = [];
        this.fullData.main = [];
        this.fullData.weight = [];

        console.group("reorganizeBPData");
        while(fromDate<=toDate)
        {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");

            let rowMain = {};
            let rowBpmAM = {};
            let rowWeightAM = {};
            let rowBpmPM = {};
            let rowWeightPM = {};
            rowMain.day = dateKey;
            rowMain.type = "main";

            rowBpmAM.day = dateKey + " 09:00:00";
            rowBpmAM.type = "BPM";
            rowBpmAM.period = "am";
            rowBpmPM.day = dateKey + " 14:00:00";
            rowBpmPM.type = "BPM";
            rowBpmPM.period = "pm";

            rowWeightAM.day = dateKey + " 09:00:00";
            rowWeightAM.type = "weight";
            rowWeightAM.period = "am";
            rowWeightPM.day = dateKey + " 14:00:00";
            rowWeightPM.type = "weight";
            rowWeightPM.period = "pm";

            let systolicAM = null;
            let diastolicAM = null;
            let systolicPM = null;
            let diastolicPM = null;

            let pulseAM = null;
            let pulsePM = null;

            let weightAM = null;
            let weightPM = null;
            if(bpData[dateKey]!=undefined)
            {
                systolicAM = bpData[dateKey].systolic_am!=undefined ? parseInt(bpData[dateKey].systolic_am): null;
                diastolicAM = bpData[dateKey].diastolic_am!=undefined ? parseInt(bpData[dateKey].diastolic_am): null;
                systolicPM = bpData[dateKey].systolic_pm!=undefined ? parseInt(bpData[dateKey].systolic_pm): null;
                diastolicPM = bpData[dateKey].diastolic_pm!=undefined ? parseInt(bpData[dateKey].diastolic_pm): null;

                pulseAM = bpData[dateKey].pulse_am!=undefined ? parseInt(bpData[dateKey].pulse_am): null;
                pulsePM = bpData[dateKey].pulse_pm!=undefined ? parseInt(bpData[dateKey].pulse_pm): null;

                weightAM = bpData[dateKey].weight_am!=undefined ? parseFloat(bpData[dateKey].weight_am): null;
                weightPM = bpData[dateKey].weight_pm!=undefined ? parseFloat(bpData[dateKey].weight_pm): null;
            }
            rowMain.ambp = [systolicAM, diastolicAM];
            rowMain.pmbp = [systolicPM, diastolicPM];

            rowBpmAM.bpm = pulseAM;
            rowBpmPM.bpm = pulsePM;

            rowWeightAM.weight = weightAM;
            rowWeightPM.weight = weightPM;

            this.fullData.main.push(rowMain);
            this.fullData.bpm.push(rowBpmAM);
            this.fullData.bpm.push(rowBpmPM);
            this.fullData.weight.push(rowWeightAM);
            this.fullData.weight.push(rowWeightPM);

            fromDate.setDate(fromDate.getDate() + 1);
        }
        console.groupEnd();
    }

    reorganizeTemperatureData(data){
        
        let dataTemperature =[]
        if (data != null) {
            dataTemperature =data !== undefined ?data.temperature_detail_list : null;
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.temperature = [];
        
        console.group("reorganizeTemperatureData");
        while (fromDate <= toDate) {
          let dateKey = moment(fromDate).format("YYYY-MM-DD");
          let rowTempAM = {}
          let rowTempPM = {}

          rowTempAM.day = dateKey + " 09:00:00";
          rowTempAM.type = "TEMP";
          rowTempAM.period = "am";

          rowTempPM.day = dateKey + " 14:00:00";
          rowTempPM.type = "TEMP";
          rowTempPM.period = "pm";
          rowTempAM.temp = dataTemperature[dateKey] ? dataTemperature[dateKey].am : null;
          rowTempPM.temp = dataTemperature[dateKey] ? dataTemperature[dateKey].pm : null;

          this.fullData.temperature.push(rowTempAM)
          this.fullData.temperature.push(rowTempPM)
          fromDate.setDate(fromDate.getDate() + 1);
        }
        console.groupEnd();
        
    }

    reorganizeBGData(data){
        console.log(data)
        let dataBG = []
        if (data != null) {
            dataBG =data !== undefined ?data.blood_glucose_detail_list : null;
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.bg = [];

        console.group("reorganizeBGData");
        while (fromDate <= toDate) {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let rowBGAM = {}
            let rowBGPM = {}

            rowBGAM.day = dateKey + " 09:00:00";
            rowBGAM.type = "BG";
            rowBGAM.period = "am";

            rowBGPM.day = dateKey + " 14:00:00";
            rowBGPM.type = "BG";
            rowBGPM.period = "pm";
            rowBGAM.bg = dataBG[dateKey] ? dataBG[dateKey].am : null;
            rowBGPM.bg = dataBG[dateKey] ? dataBG[dateKey].pm : null;

            this.fullData.bg.push(rowBGAM)
            this.fullData.bg.push(rowBGPM)
            fromDate.setDate(fromDate.getDate() + 1);
        }
        console.log(this.fullData);
        console.groupEnd();
    }

    reorganizeSpo2Data(data){
        console.log(data)
        let dataSpo2 = []
        if (data != null) {
            dataSpo2 =data !== undefined ?data.spo2_detail_list : null;
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.spo2 = [];

        console.group("reorganizeSpo2Data");
        while (fromDate <= toDate) {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let rowSPO2AM = {}
            let rowSPO2PM = {}

            rowSPO2AM.day = dateKey + " 09:00:00";
            rowSPO2AM.type = "SPO2";
            rowSPO2AM.period = "am";

            rowSPO2PM.day = dateKey + " 14:00:00";
            rowSPO2PM.type = "SPO2";
            rowSPO2PM.period = "pm";
            rowSPO2AM.spo2 = dataSpo2[dateKey] ? dataSpo2[dateKey].am : null;
            rowSPO2PM.spo2 = dataSpo2[dateKey] ? dataSpo2[dateKey].pm : null;

            this.fullData.spo2.push(rowSPO2AM)
            this.fullData.spo2.push(rowSPO2PM)
            fromDate.setDate(fromDate.getDate() + 1);
        }
        console.log(this.fullData);
        console.groupEnd();
    }

    reorganizeStepData(data){

        console.log(data)
        
        let stepData = [];
        let stepGoal = null;
        if(data !== null ){
            stepData = data.step_detail_list;
            if(data.step_goal !== null && data.step_goal !== undefined){
                stepGoal = data.step_goal.step_goal !== undefined ? data.step_goal.step_goal : null;
            }
            this.setState({
                stepGoal:stepGoal
            });
        }

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.step = [];

        while(fromDate<=toDate) {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let dateStep = null;
            let items = stepData.filter(entry => (entry.date === dateKey));
            if(items.length > 0){
                items.forEach(element => {
                    if (element.step != undefined || element.step != null) {
                        dateStep = element.step;
                    }
                });
            }

            let rowSept = {};
            rowSept.day = dateKey;
            rowSept.type = "step";
            rowSept.step = dateStep;
            this.fullData.step.push(rowSept);
            fromDate.setDate(fromDate.getDate() + 1);
        }

        console.groupEnd();
    }

    reorganizeSleepData(data){
        let sleepData = [];
        let sleep_time = null;
        let wake_up_time = null;
        if(data !== null ){
            sleepData =data.sleep_detail_list;
            if(data.sleep_goal !== undefined &&data.sleep_goal !== null){
                sleep_time = data.sleep_goal.sleep_time !== undefined ?data.sleep_goal.sleep_time : null;
                wake_up_time =data.sleep_goal.wake_up_time !== undefined ?data.sleep_goal.wake_up_time : null;
            }
        }
        this.setState({
            sleepTime: sleep_time,
            wakeUpTime: wake_up_time
        });

        let fromDate = this.convertToDate(this.state.fromDate);
        let toDate = this.convertToDate(moment(this.convertToDate(this.state.toDate)).format("YYYY-MM-DD"));
        this.fullData.sleep = [];

        while(fromDate<=toDate) {
            let dateKey = moment(fromDate).format("YYYY-MM-DD");
            let duration = null;
            let sleepTime = null;
            let wakeUpTime = null;
            let items = sleepData.filter(entry => (entry.date === dateKey));
            if(items.length > 0){
                items.forEach(element => {
                    if (element.duration != undefined || element.duration != null) {
                        duration = element.duration;
                        sleepTime = element.sleep_time;
                        wakeUpTime = element.wake_up_time;
                    }
                });
            }

            let rowSept = {};
            rowSept.day = dateKey;
            rowSept.type = "sleep";
            rowSept.duration = duration;
            rowSept.sleepTime = sleepTime;
            rowSept.sleepTimeToMinute = this.ChangeStrToMinutes(sleepTime);
            rowSept.wakeUpTime = wakeUpTime;
            rowSept.wakeUpTimeToMinute = this.ChangeStrToMinutes(wakeUpTime);
            rowSept.durationTime = [rowSept.wakeUpTimeToMinute,rowSept.sleepTimeToMinute];
            this.fullData.sleep.push(rowSept);
            fromDate.setDate(fromDate.getDate() + 1);
        }
        console.log(this.fullData);
        console.groupEnd();
    }

    reorganizeGoalSysDiaData(data){
        if(data==null || data.length==0) return;
        if(data.sys_goal !== null){
            this.setState({
                sysGoal:data.sys_goal,
            });
        }
        if(data.dia_goal != null){
            this.setState({
                diaGoal:data.dia_goal,
            });
        }

    }

    renderMEWCCheck = (props) => {
        // console.group("renderMEWCCheck");
        // console.log(props);
        // console.groupEnd();
        const {cx, cy, payload} = props;

        if(payload.checkMEWC == null) return null;
        // maskBarPositions
        const domain = props.xAxis.domain;
        const index = domain.indexOf(props.day);
        const pIndex = parseInt(index/2);

        let x = this.state.maskBarPositions[pIndex];
        let icon = null;
        let fixX = 0;

        if(payload.period == 'am')
        {
            icon = (
                <svg x={x - fixX} y={cy} width="12px" height="12px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <g id="MEWC-V2" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                        <g id="mewc-graph-4" transform="translate(-152.000000, -755.000000)">
                            <g id="Group-8" transform="translate(0.000000, 159.000000)">
                                <g id="Group-4">
                                    <g id="Group-13" transform="translate(9.000000, 419.000000)">
                                        <g id="Group">
                                            <g id="Group-13" transform="translate(66.000000, 20.000000)">
                                                <g id="icon/30px/check_green-outline" transform="translate(77.000000, 157.000000)">
                                                    <g id="icon/30px/check_blue-outline">
                                                        <path d="M7.5,0.763888889 C3.69598652,0.763888889 0.625,3.79696199 0.625,7.5462963 C0.625,11.2956306 3.69598652,14.3287037 7.5,14.3287037 C11.3040135,14.3287037 14.375,11.2956306 14.375,7.5462963 C14.375,3.79696199 11.3040135,0.763888889 7.5,0.763888889 Z" id="Path" stroke="#7ED321" strokeWidth="1.25" fillRule="nonzero"></path>
                                                        <path d="M11.1290323,6.01019799 L6.68778802,10.3795443 C6.54953917,10.5160864 6.37672811,10.5843574 6.20391705,10.5843574 C6.03110599,10.5843574 5.84101382,10.5160864 5.72004608,10.3795443 L3.52534562,8.22900666 C3.24884793,7.95592251 3.24884793,7.52922854 3.52534562,7.25614439 C3.80184332,6.98306025 4.23387097,6.98306025 4.51036866,7.25614439 L6.20391705,8.92878478 L10.1440092,5.03733572 C10.4205069,4.76425158 10.8525346,4.76425158 11.1290323,5.03733572 C11.3882488,5.31041987 11.3882488,5.7541816 11.1290323,6.01019799 Z" id="Path" fill="#7ED321" fillRule="nonzero"></path>
                                                    </g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
            )
        }

        return (
            <g>
                {icon}
            </g>
        );
    }

    convertToDate(strDate)
    {
        if( strDate == undefined || strDate.replace == undefined) return strDate;
        if(strDate==null || strDate==undefined) return null;

        strDate = strDate.replace(/-/g,"/");
        return new Date(strDate);
    }

    ChangeStrToMinutes(str)
    {
        if(str === null || str === 0 ) return null;
        var arrminutes = str.split(":");
        if (arrminutes.length == 2) {
            var minutes = parseInt(arrminutes[0]) * 60 + parseInt(arrminutes[1]);
            if(minutes > 720){
                minutes = minutes - 720
            }else{
                minutes = minutes + 720
            }
            return minutes;
        }
        else {
            return 0;
        }
    }

    formatAMPM(time) {
        if(!time) return null;
        // Check correct time format and split into components
        time = time.toString ().match (/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

        if (time.length > 1) { // If time format correct
            time = time.slice (1);  // Remove full string match value
            time[5] = +time[0] < 12 ? 'am' : 'pm'; // Set AM/PM
            time[0] = +time[0] % 12 || 12; // Adjust hours
        }
        return time.join (''); // return adjusted time or original string
    }

    getHoursMinute(minute){
        if(!minute) return '--';
        let hours = Math.floor(parseInt(minute) / 60 );
        let minu = parseInt(minute) % 60;
        return hours +' h '+ minu + ' min';

    }

    getSleepYAxisTicks(data,count,decimals,offset){

        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];
        //
        for(var i=0;i<data.length;i++)
        {
            if(data[i].sleepTime!=null)
            {
                arr.push(this.ChangeStrToMinutes(data[i].sleepTime));
            }

            if(data[i].wakeUpTime!=null)
            {
                arr.push(this.ChangeStrToMinutes(data[i].wakeUpTime));
            }
        }

        let ticks = [360 ,540,720,900,1080,1260,1440];
        let result = {interval:180, ticks:ticks};
        return result;
    }

    getFeelingYAxisTicks(data,count,decimals,offset){
        if(data==null) return {interval:0, ticks:[0]};

        let arr = [];

        for(var i=0;i<data.length;i++)
        {
            if(data[i].feelings.feeling!=null)
            {
                arr.push(data[i].feelings.feeling);
            }
        }

        let min = 0;
        let max = 100;
        if(arr.length>0)
        {
            min = Math.min.apply(null, arr);
            max = Math.max.apply(null, arr);
        }

        return this.getYAxisTicks(min, max, count, decimals, offset);


        // let ticks = [1,2,30,40,50];
        // return {interval:1, ticks:ticks};
    }

    /**
     * Render
     *
     * @returns {JSX.Element}
     * @memberof Graph
     */
    render() {

        const chartMargin = { top: 10, right: 5, bottom: 10, left: -8 };
        const bpTicks = this.getBPYAxisTicks(this.fullData.main,4,0,10);
        const bpmTicks = this.getBPMYAxisTicks(this.fullData.bpm,4,0,5);
        const tempTicks = this.getTEMPYAxisTicks(this.fullData.temperature,4,0,5);
        const spo2Ticks = this.getSPO2YAxisTicks(this.fullData.spo2, 4, 0, 5);
        const bgTicks = this.getBGYAxisTicks(this.fullData.bg, 4, 0, 5);
        
        const weightTicks = this.getWeightYAxisTicks(this.state.dataWeight,4,1,0.5);
        const stepTicks = this.getStepYAxisTicks(this.fullData.step,4,0,5);
        const sleepTicks = this.getSleepYAxisTicks(this.fullData.sleep,3,0,180);
        const feelingTicks = this.getFeelingYAxisTicks(this.state.data,5,0,1);
        let sleepTimeToMinu = this.ChangeStrToMinutes(this.state.sleepTime);
        let wakeUpTimeToMinu = this.ChangeStrToMinutes(this.state.wakeUpTime);
        let sleepTimeScale  = this.formatAMPM(this.state.sleepTime);
        let wakeUpTimeScale  = this.formatAMPM(this.state.wakeUpTime);

        let feelings = [];
        let feelingMoodDisplay = 'none';

        if(this.state.data !== null){
            let stemp_data = this.state.data;
            for(var i=0;i<stemp_data.length;i++)
            {
                if(stemp_data[i].feelings.mood !== null){
                    feelingMoodDisplay = 'block';
                }

                if(stemp_data[i].feelings !=null)
                {
                    feelings.push({
                        feeling:stemp_data[i].feelings.feeling + 10,
                        feelings:stemp_data[i].feelings,
                        day:stemp_data[i].day
                    });
                }
            }
        }
        let bpIconUrl = null;
        let bgIconUrl = null;
        let spo2IconUrl = null;
        let weightIconUrl = null;
        let stepIconUrl = null;
        let sleepIconUrl = null;
        let feelingIconUrl = null;
        let feelingDesc = null;

        if(this.state.dataDiff.weight !== undefined && this.state.dataDiff.weight !== 0 && this.state.dataDiff.weight !== null){
            if(this.state.dataDiff.weight > 0){
                weightIconUrl = iconUpArrow;
            }else{
                weightIconUrl = iconDownArrow;
            }
        }
        if (this.state.dataDiff.bg !== undefined && this.state.dataDiff.bg !== 0 && this.state.dataDiff.bg !== null) {
            if (this.state.dataDiff.bg > 0) {
                bgIconUrl = iconUpArrow;
            } else {
                bgIconUrl = iconDownArrow;
            }
        }
        if (this.state.dataDiff.spo2 !== undefined && this.state.dataDiff.spo2 !== 0 && this.state.dataDiff.spo2 !== null) {
            if (this.state.dataDiff.spo2 > 0) {
                spo2IconUrl = iconUpArrow;
            } else {
                spo2IconUrl = iconDownArrow;
            }
        }
        if(this.state.dataDiff.step !== undefined && this.state.dataDiff.step !== 0 && this.state.dataDiff.step !== null){
            if(this.state.dataDiff.step > 0){
                stepIconUrl = iconUpArrow;
            }else{
                stepIconUrl = iconDownArrow;
            }
        }

        if(this.state.dataDiff.sleep !== undefined && this.state.dataDiff.sleep !== 0 && this.state.dataDiff.sleep !== null){
            if(this.state.dataDiff.sleep > 0){
                sleepIconUrl = iconUpArrow;
            }else{
                sleepIconUrl = iconDownArrow;
            }
        }
        if(this.state.dataDiff.feeling !== undefined && this.state.dataDiff.feeling !== 0 && this.state.dataDiff.feeling !== null){
            if(this.state.dataDiff.feeling > 0){
                feelingIconUrl = iconUpArrow;
                feelingDesc = "Mood has improved over the week! ";
            }else{
                feelingIconUrl = iconDownArrow;
                feelingDesc = "Not as great as last week, try to think positive!";
            }
        }

        return <div className="charts-main">
            <div style={{ position: "absolute", zIndex: 9999, top: 0, left: 0, backgroundColor: "transparent", width: "100%", height: "100%", pointerEvents: "none" }}>
              {/* <div id="divMaskCircle" style={{width:"46px",height:"46px",background:'#32B5FB',opacity:0.1,position:'absolute',borderRadius:"50%", top:33,left:this.state.maskBarCircle.x}}/> */}
              <div id="divMask" style={{ width: "12%", height: "94%", background: "#C23579", opacity: 0.1, position: "absolute", top: 100, left: this.state.maskBar.x }} />

                <div id="divToolTipTemp" className="dialogbox" style={{ zIndex: 9999, top: 70, position: "absolute", left: this.state.tipBoxTemperature.x, width: "130px", height: "150px" }}>
                    <div className="body">
                        <div>
                            <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                                <div style={{ position: "absolute", top: "10px", display: "flex", alignItems: "center" }}>
                                    <img src={morningWhite} width={20} height="auto" />
                                    <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                        {this.state.curTemperatureData.amTemp} ℃
                                    </span>
                                </div>
                            </div>
                            <hr className="hrWhiteLine" />
                            <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                                <div style={{ position: "absolute", top: "50px", display: "flex", alignItems: "center" }}>
                                    <img src={nightWhite} width={20} height="auto" />
                                    <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                        {this.state.curTemperatureData.pmTemp} ℃
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
              </div>
                <div id="divTipDown" className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxTemperature.arrowY, left: this.state.tipBoxTemperature.arrowX, zIndex: 9000 }} />

                <div id="divToolTipBP" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxBP.y, position: "absolute", left: this.state.tipBoxBP.x, width: "250px", height: "150px" }}>
                <div className="body">
                  <div>
                    <div style={{ paddingLeft: "10px", paddingRight: "5px", paddingTop: "5px", height: "20px" }}>
                      <div style={{ position: "absolute", top: "13px", display: "flex", alignItems: "center" }}>
                        <img src={morningWhite} width={20} height="auto" margin-top={20} />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curBPData.ambp} mmHg
                        </span>
                        <img src={bpmWhite} width={20} height="auto" style={{ paddingLeft: "7px" }} />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curBPMData.ambpm} bpm
                        </span>
                      </div>
                    </div>
                    <hr className="hrWhiteLine" />
                    <div style={{ paddingLeft: "10px", paddingRight: "5px", height: "20px" }}>
                      <div style={{ position: "absolute", top: "55px", display: "flex", alignItems: "center" }}>
                        <img src={nightWhite} width={20} height="auto" />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curBPData.pmbp} mmHg
                        </span>
                        <img src={bpmWhite} width={20} height="auto" style={{ paddingLeft: "7px" }} />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curBPMData.pmbpm} bpm
                        </span>
                      </div>
                    </div>
                    <div className="tip-down" />
                  </div>
                </div>
              </div>
                <div id="divTipDown" className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxBP.arrowY, left: this.state.tipBoxBP.arrowX, zIndex: 9000 }} />

              <div id="divToolTipWeight" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxWeight.y , position: "absolute", left: this.state.tipBoxWeight.x, width: "130px", height: "150px" }}>
                <div className="body">
                  <div>
                    <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                      <div style={{ position: "absolute", top: "10px", display: "flex", alignItems: "center" }}>
                        <img src={morningWhite} width={20} height="auto" />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curWeightData.amweight} kg
                        </span>
                      </div>
                    </div>
                    <hr className="hrWhiteLine" />
                    <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                      <div style={{ position: "absolute", top: "50px", display: "flex", alignItems: "center" }}>
                        <img src={nightWhite} width={20} height="auto" />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curWeightData.pmweight} kg
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxWeight.arrowY, left: this.state.tipBoxWeight.arrowX, zIndex: 9000 }} />

              <div id="divToolTipStep" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxStep.y, position: "absolute", left: this.state.tipBoxStep.x, width: "130px", height: "150px" }}>
                <div className="body">
                  <div>
                    <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "30px" }}>
                      <div style={{ position: "absolute", top: "10px", bottom: "10px", display: "flex", alignItems: "center" }}>
                        <img src={iconWhiteRunningMan} width={20} height="auto" />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curStepData.step} steps
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxStep.arrowY, left: this.state.tipBoxStep.arrowX, zIndex: 9000 }} />

                <div id="divToolTipSleep" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxSleep.y, position: "absolute", left: this.state.tipBoxSleep.x, width: "130px", height: "150px" }}>
                <div className="body">
                  <div>
                    <div style={{ paddingLeft: "10px", paddingRight: "5px", paddingTop: "5px", height: "20px" }}>
                      <div style={{ position: "absolute", top: "13px", display: "flex", alignItems: "center" }}>
                        <img src={morningWhite} width={20} height="auto" margin-top={20} />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curSleepData.wake_up_time}
                        </span>
                      </div>
                    </div>
                    <hr className="hrrWhiteLine" />
                    <div style={{ paddingLeft: "10px", paddingRight: "5px", height: "20px" }}>
                      <div style={{ position: "absolute", display: "flex", alignItems: "center" }}>
                        <img src={nightWhite} width={20} height="auto" />
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curSleepData.sleep_time}
                        </span>
                      </div>
                    </div>
                    <hr className="hrWhiteLine_v2" />
                    <div style={{ paddingLeft: "10px", paddingRight: "5px", height: "20px" }}>
                      <div style={{ position: "absolute", display: "flex", alignItems: "center" }}>
                        <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                          {this.state.curSleepData.duration}
                        </span>
                      </div>
                    </div>
                    <div className="tip-down" />
                  </div>
                </div>
              </div>
              <div id="divTipDown" className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxSleep.arrowY, left: this.state.tipBoxSleep.arrowX, zIndex: 9000 }} />

              <div id="divToolTipCondition" className="dialogbox" style={{ position: "absolute", top: this.state.tipBoxCondition.y, left: this.state.tipBoxCondition.x }}>
                <div className="body" style={{ width: this.state.tipBoxCondition.width, height: "50px" }}>
                    <div style={{ position: "relative", paddingLeft: "5px", paddingRight: "5px", paddingTop: "8px" }} height={35}>
                        <div dangerouslySetInnerHTML={{ __html: this.state.tipBoxCondition.content }} />
                    </div>
                </div>
              </div>
              <div className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxCondition.arrowY, left: this.state.tipBoxCondition.arrowX, zIndex: 9000 }} />

                <div id="divToolTipBg" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxBG.y, position: "absolute", left: this.state.tipBoxBG.x, width: "130px", height: "150px" }}>
                <div className="body">
                    <div>
                        <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                            <div style={{ position: "absolute", top: "10px", display: "flex", alignItems: "center" }}>
                                <img src={morningWhite} width={20} height="auto" />
                                <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                    {this.state.curBGData.ambg} mmol/L
                            </span>
                            </div>
                        </div>
                        <hr className="hrWhiteLine" />
                        <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                            <div style={{ position: "absolute", top: "50px", display: "flex", alignItems: "center" }}>
                                <img src={nightWhite} width={20} height="auto" />
                                <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                    {this.state.curBGData.pmbg} mmol/L
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div id="divTipDown" className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxBG.arrowY, left: this.state.tipBoxBG.arrowX, zIndex: 9000 }} />


                <div id="divToolTipSpo2" className="dialogbox" style={{ zIndex: 9999, top: this.state.tipBoxSpo2.y, position: "absolute", left: this.state.tipBoxSpo2.x, width: "130px", height: "150px" }}>
                <div className="body">
                    <div>
                        <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                            <div style={{ position: "absolute", top: "10px", display: "flex", alignItems: "center" }}>
                                <img src={morningWhite} width={20} height="auto" />
                                <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                    {this.state.curSpo2Data.amspo2} %
                            </span>
                            </div>
                        </div>
                        <hr className="hrWhiteLine" />
                        <div style={{ paddingLeft: "10px", paddingRight: "15px", height: "20px" }}>
                            <div style={{ position: "absolute", top: "50px", display: "flex", alignItems: "center" }}>
                                <img src={nightWhite} width={20} height="auto" />
                                <span style={{ paddingLeft: "7px" }} className="tipTextMessage">
                                    {this.state.curSpo2Data.pmspo2} %
                            </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
                <div id="divTipDown" className="tip tip-down" style={{ position: "absolute", top: this.state.tipBoxSpo2.arrowY, left: this.state.tipBoxSpo2.arrowX, zIndex: 9000 }} />
            </div>

            <div className="fixedDiv" style={{ zIndex: 10000, top: "0px", left: "0px", width: "100%", height: "20px", backgroundColor: "white" }}>
              <div id="divMaskCircle" style={{ width: "40px", height: "40px", background: "#C23579", position: "absolute", borderRadius: "50%", top: 45, left: this.state.maskBarCircle.x }} />
              <div className="scatter-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
                <ResponsiveContainer width="100%" height={80}>
                  <ScatterChart syncId="measurement" width={400} height={80} margin={{ top: 7, right: 10, bottom: 20, left: -45 }}>
                    <XAxis hide={true} type="category" dataKey="day" />
                    <YAxis dataKey="day" height={10} width={80} tick={false} tickLine={false} axisLine={false} />
                    {/* <Tooltip cursor={{strokeDasharray: '3 3'}} wrapperStyle={{ zIndex: 100 }} content={this.renderTooltip} /> */}
                    <Scatter data={this.state.data} shape={this.renderCalendar} onClick={this.handleBPBarClick} />
                  </ScatterChart>
                </ResponsiveContainer>
              </div>
            </div>
            <div style={{ zIndex: 10000, position: "relative", top: "0px", left: "0px", width: "100%", height: "90px", backgroundColor: "transparent", pointerEvents: "none" }} />

            <div className="divSection" />

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Temperature</div>
              <p className="mobile-graph-unit">℃</p>
                <ResponsiveContainer width="100%" height={120} id="chartTemp">
                  <LineChart width={400} height={120} data={this.state.dataTemperature} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" padding={{ left: 15, right: 10 }} hide={true} interval="preserveStartEnd" />
                  {/* <YAxis type="number" tickCount={6} interval={0} domain={['dataMin - 0', 'dataMax + 10']} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />}/> */}
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={tempTicks.ticks} axisLine={false} tickLine={false} tick={<RenderTEMPYAxisTick />} />
                  <Line dataKey="temp" stroke={greenColor} connectNulls={true} legendType="square" dot={this.renderTEMDot} />
                  <ReferenceLine y={this.state.temperatureGoal} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={this.state.temperatureGoal} position="insideLeft" content={this.renderLabelContent} />
                  </ReferenceLine>
                </LineChart>
              </ResponsiveContainer>
            </div>

            <div className="divSection" />

            <div className="bar-chart-wrapper" style={{ backgroundColor: "#ffffff" }}>
              <div className="mobile-graph-title">Blood Pressure</div>
              <p className="mobile-graph-unit">mmHg</p>
              <ResponsiveContainer width="100%" height={120} id="chartBP">
                <BarChart syncId="measurement" width={400} height={120} backgroundColor="#000000" barCategoryGap={0} data={this.state.data} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis hide={true} dataKey="day" />
                  {/* <YAxis type="number" tickCount={6} interval={0} domain={['dataMin - 10', 'dataMax + 10']} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />}> */}
                  <YAxis type="number" tickCount={6} interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={bpTicks.ticks} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />} />
                  {/* <Tooltip content={<this.RenderBpGraphTooltip external={this.state.data} />} position={{y:-80}} cursor={false}/> */}
                  <Bar dataKey="ambp" fill="#97E1E6" barSize={8} barGap={0} radius={4} />
                  <Bar dataKey="pmbp" fill="#00989E" stroke={greenColor} barSize={8} radius={4} />
                  {this.state.sysGoal ? <ReferenceLine y={this.state.sysGoal} stroke="#C23579" ifOverflow="extendDomain">
                      <Label value={this.state.sysGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}
                  {this.state.diaGoal ? <ReferenceLine y={this.state.diaGoal} stroke="#C23579" ifOverflow="extendDomain">
                      <Label value={this.state.diaGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}
                </BarChart>
              </ResponsiveContainer>
            </div>

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <p className="mobile-graph-unit">bpm</p>
              <ResponsiveContainer width="100%" height={120}>
                <LineChart width={400} height={120} data={this.state.dataBPM} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" padding={{ left: 15, right: 10 }} hide={true} interval="preserveStartEnd" />
                  {/* <YAxis type="number" tickCount={6} interval={0} domain={['dataMin - 0', 'dataMax + 10']} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />}/> */}
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={bpmTicks.ticks} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />} />
                  <Line dataKey="bpm" stroke={greenColor} connectNulls={true} legendType="square" dot={this.renderBPMDot} />
                  {/* <Line dataKey="ambpm" stroke={blueColor} connectNulls={true} legendType="square"/>
                            <Line dataKey="pmbpm" stroke={redColor} connectNulls={true} legendType="square"/> */}
                </LineChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.abpm}
                </b>/<b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.pbpm}
                </b> mmHg <b
                  style={{ fontSize: "17px", marginLeft: "5px" }}
                >
                  {this.state.dataAverage.bpm}
                </b> bpm {bpIconUrl ? <img src={bpIconUrl} width={12} height="auto" /> : ""}
              </p>
            </div>

            <div className="divSection" />

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Weight</div>
              <p className="mobile-graph-unit">kg</p>
              <ResponsiveContainer width="100%" height={200} id="chartWeight">
                <ComposedChart syncId="measurement" width={400} height={200} data={this.state.dataWeight} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <defs>
                    <linearGradient id="weight_pm" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#FFC4E6" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#FF91C8" stopOpacity={0} />
                    </linearGradient>
                    <linearGradient id="weight_am" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="5%" stopColor="#C6F5F8" stopOpacity={0.8} />
                      <stop offset="95%" stopColor="#97E1E6" stopOpacity={0} />
                    </linearGradient>
                  </defs>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  {/* <Tooltip content={<this.RenderWeightGraphTooltip external={this.state.dataWeight} />}/> */}
                  {/*xAxisId="weight"*/}
                  <XAxis dataKey="day" hide={true} padding={{ left: 1, right: 0 }} />
                  <YAxis type="number" tickCount={6} interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={weightTicks.ticks} axisLine={false} tickLine={false} tick={<RenderWeightYAxisTick />} />
                  {/*<Line dataKey="weight" stroke={greenColor} filterNull={false} connectNulls={true} legendType="square" dot={this.renderWeightMDot}/>*/}
                  <Area type="monotone" dataKey="weight_pm" stroke="#FFC4E6" fillOpacity={1} fill="url(#weight_pm)" connectNulls={true} dot={this.renderWeightMDotPM} />
                  <Area type="monotone" dataKey="weight_am" stroke="#C6F5F8" fillOpacity={1} fill="url(#weight_am)" connectNulls={true} dot={this.renderWeightMDot} />
                  {this.fullData.mewc != null ? <Line dataKey="weightMEWC" stroke="#6DD000" filterNull={true} connectNulls={false} legendType="square" dot={false} /> : ""}
                  {this.fullData.mewc != null ? <ReferenceLine y={this.fullData.mewc.startWeight} stroke="#C23579" ifOverflow="extendDomain">
                      <Label value={this.fullData.mewc.startWeight} position="insideLeft" content={this.renderWeightReferenceLabelContent} />
                    </ReferenceLine> : ""}
                  {this.fullData.mewc != null ? <ReferenceLine y={this.fullData.mewc.goalWeight} stroke="#C23579" ifOverflow="extendDomain">
                      <Label value={this.fullData.mewc.goalWeight} position="insideLeft" content={this.renderWeightReferenceLabelContent} />
                    </ReferenceLine> : ""}
                  {this.fullData.mewc != null ? <ReferenceLine x={this.fullData.mewc.startDate} stroke="lightGray">
                      <Label value="Start" position="center" content={this.renderMEWCStartLabel} />
                    </ReferenceLine> : ""}
                  {this.fullData.mewc != null ? <Scatter data={this.state.dataWeight} shape={this.renderMEWCCheck} /> : ""}
                  {this.state.weightHGoal ? <ReferenceLine y={this.state.weightHGoal} stroke="#C23579" ifOverflow="extendDomain">
                        <Label value={this.state.weightHGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}
                    {this.state.weightLGoal ? <ReferenceLine y={this.state.weightLGoal} stroke="#C23579" ifOverflow="extendDomain">
                        <Label value={this.state.weightLGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}
                </ComposedChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.weight}
                </b> kg {weightIconUrl ? <img src={weightIconUrl} width={12} height="auto" /> : ""}
              </p>
            </div>

            <div className="divSection" />

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Steps</div>
              <p className="mobile-graph-unit">no.</p>
              <ResponsiveContainer width="100%" height={200} id="chartStep">
                <LineChart width={400} height={200} data={this.state.dataStep} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" padding={{ left: 15, right: 25 }} hide={true} interval="preserveStartEnd" />
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={stepTicks.ticks} axisLine={false} tickLine={false} tick={<RenderStepYAxisTick />} />
                  <Line dataKey="step" stroke="#00989E" connectNulls={true} legendType="square" dot={this.renderStepDot} />
                  <ReferenceLine y={this.state.stepGoal} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={this.state.stepGoal} position="insideLeft" content={this.renderLabelContent} />
                  </ReferenceLine>
                </LineChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "18px" }}>
                  {this.state.dataAverage.step}
                </b> steps {stepIconUrl ? <img src={stepIconUrl} width={12} height="auto" /> : ""}{" "}
              </p>
            </div>

            <div className="divSection" />

            <div className="bar-chart-wrapper" style={{ backgroundColor: "#ffffff" }}>
              <div className="mobile-graph-title">Sleep</div>
              <p className="mobile-graph-unit">time</p>
              <ResponsiveContainer width="100%" height={150} id="chartSleep">
                <BarChart syncId="measurement" width={400} height={150} backgroundColor="#000000" barCategoryGap={0} data={this.state.dataSleep} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis hide={true} dataKey="day" />
                  {/*<Bar dataKey="durationTime" fill="#00989E" stroke="#C6F5F8" barSize={8} barGap={0} radius={4}/>*/}
                  <Bar dataKey="durationTime" fill="#97E1E6" stroke="#C6F5F8" barSize={14} radius={7} />
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={sleepTicks.ticks} axisLine={false} tickLine={false} tick={<RenderSleepYAxisTick />} />
                  <ReferenceLine y={wakeUpTimeToMinu} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={wakeUpTimeScale} position="insideLeft" content={this.renderSleepLabelContent} />
                  </ReferenceLine>
                  <ReferenceLine y={sleepTimeToMinu} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={sleepTimeScale} position="insideLeft" content={this.renderSleepLabelContent} />
                  </ReferenceLine>
                </BarChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.sleep_h}
                </b> hr <b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.sleep_m}
                </b> min {sleepIconUrl ? <img src={sleepIconUrl} width={12} height="auto" /> : ""}
              </p>
            </div>

            <div className="divSection" />

            <div className="scatter-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Mood</div>
              <p className="mobile-graph-unit"></p>
              <div style={{ display: feelingMoodDisplay }}>
                <ResponsiveContainer width="100%" height={100} id="chartCondition">
                  <ScatterChart syncId="measurement" width={400} height={100} margin={{ top: 0, right: 15, bottom: 0, left: -30 }} data={feelings}>
                    <XAxis hide={true} type="category" dataKey="day" />
                    <YAxis dataKey="feeling" tickCount={10} interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={feelingTicks.ticks} axisLine={false} tickLine={false} tick={false} />
                    {/*<YAxis type="feeling" tickCount={6} interval={0} domain={['dataMin - 0', 'dataMax + 0']} ticks={feelingTicks.ticks} axisLine={false} tickLine={false} tick={true} />*/}
                    {/* <Tooltip cursor={{strokeDasharray: '3 3'}} wrapperStyle={{ zIndex: 100 }} content={this.renderTooltip} /> */}
                    <Scatter onClick={this.handleBPBarClick} shape={this.renderConditionIcons} />
                  </ScatterChart>
                </ResponsiveContainer>
                <p className="mobile-graph-down">
                  {feelingDesc ? feelingDesc : ""} {feelingIconUrl ? <img src={feelingIconUrl} width={12} height="auto" /> : ""}
                </p>
              </div>
            </div>

            <div className="divSection" />

            <div className="scatter-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Medication</div>
              <div style={{ display: this.state.medicationDisplay.morning }}>
                <ResponsiveContainer width="100%" height={50}>
                  <ScatterChart syncId="measurement" width={400} height={50} margin={{ top: 0, right: 10, bottom: 20, left: -40 }}>
                    <XAxis hide={true} type="category" dataKey="day" />
                    <YAxis dataKey="ammc" height={10} width={80} tick={false} tickLine={false} axisLine={false} label={<RenderMCPeriodIcon external="morning" />} />
                    {/* <Tooltip cursor={{strokeDasharray: '3 3'}} wrapperStyle={{ zIndex: 100 }} content={this.renderTooltip} /> */}
                    <Scatter onClick={this.handleBPBarClick} data={this.state.data} shape={<RenderMCXAxisTick />} />
                  </ScatterChart>
                </ResponsiveContainer>
              </div>

              <div style={{ display: this.state.medicationDisplay.noon }}>
                <ResponsiveContainer width="100%" height={50}>
                  <ScatterChart syncId="measurement" width={400} height={50} margin={{ top: 7, right: 10, bottom: 20, left: -40 }}>
                    <XAxis hide={true} type="category" dataKey="day" />
                    <YAxis dataKey="nnmc" height={10} width={80} tick={false} tickLine={false} axisLine={false} label={<RenderMCPeriodIcon external="noon" />} />
                    <Scatter onClick={this.handleBPBarClick} data={this.state.data} shape={<RenderMCXAxisTick />} />
                  </ScatterChart>
                </ResponsiveContainer>
              </div>

              <div style={{ display: this.state.medicationDisplay.evening }}>
                <ResponsiveContainer width="100%" height={50}>
                  <ScatterChart syncId="measurement" width={400} height={50} margin={{ top: 7, right: 10, bottom: 20, left: -40 }}>
                    <XAxis hide={true} type="category" dataKey="day" />
                    <YAxis dataKey="pmmc" height={10} width={80} tick={false} tickLine={false} axisLine={false} label={<RenderMCPeriodIcon external="evening" />} />
                    <Scatter onClick={this.handleBPBarClick} data={this.state.data} shape={<RenderMCXAxisTick />} />
                  </ScatterChart>
                </ResponsiveContainer>
              </div>
            </div>

            <div className="divSection" />

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title">Blood Glucose</div>
              <p className="mobile-graph-unit">mmol/L</p>
                <ResponsiveContainer width="100%" height={120} id="chartBg">
                  <LineChart width={400} height={120} data={this.state.dataBG} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" padding={{ left: 15, right: 10 }} hide={true} interval="preserveStartEnd" />
                  {/* <YAxis type="number" tickCount={6} interval={0} domain={['dataMin - 0', 'dataMax + 10']} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />}/> */}
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={bgTicks.ticks} axisLine={false} tickLine={false} tick={<RenderBGYAxisTick />} />
                  <Line dataKey="bg" stroke={greenColor} connectNulls={true} legendType="square" dot={this.renderBGDot} />
                    {this.state.glucoseBeforeMealHGoal ? <ReferenceLine y={this.state.glucoseBeforeMealHGoal} stroke="#C23579" ifOverflow="extendDomain">
                        <Label value={this.state.glucoseBeforeMealHGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}

                    {this.state.glucoseBeforeMealLGoal ? <ReferenceLine y={this.state.glucoseBeforeMealLGoal} stroke="#C23579" ifOverflow="extendDomain">
                        <Label value={this.state.glucoseBeforeMealLGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}

                    {this.state.glucoseAfterMealHGoal ? <ReferenceLine y={this.state.glucoseAfterMealHGoal} stroke="#C23579" ifOverflow="extendDomain">
                        <Label value={this.state.glucoseAfterMealHGoal} position="insideLeft" content={this.renderLabelContent} />
                    </ReferenceLine> : ""}

                    {this.state.glucoseAfterMealLGoal ? <ReferenceLine y={this.state.glucoseAfterMealLGoal} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={this.state.glucoseAfterMealLGoal} position="insideLeft" content={this.renderLabelContent} />
                </ReferenceLine> : ""}
                </LineChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "17px" }}>
                {this.state.dataAverage.bg}
                </b> mmol/L {bgIconUrl ? <img src={bgIconUrl} width={12} height="auto" /> : ""}
              </p>
            </div>

            <div className="divSection" />

            <div className="line-chart-wrapper" style={{ backgroundColor: "#ffffff", marginTop: "10px" }}>
              <div className="mobile-graph-title"> SPO2 </div>
              <p className="mobile-graph-unit">％</p>
                <ResponsiveContainer width="100%" height={120} id="chartSpo2">
                  <LineChart width={400} height={120} data={this.state.dataSpo2} margin={chartMargin} onClick={this.handleBPBarClick}>
                  <CartesianGrid strokeDasharray="3 3" vertical={false} />
                  <XAxis dataKey="day" padding={{ left: 15, right: 10 }} hide={true} interval="preserveStartEnd" />
                  {/* <YAxis type="number" tickCount={6} interval={0} domain={['dataMin - 0', 'dataMax + 10']} axisLine={false} tickLine={false} tick={<RenderBPYAxisTick />}/> */}
                  <YAxis type="number" interval={0} domain={["dataMin - 0", "dataMax + 0"]} ticks={spo2Ticks.ticks} axisLine={false} tickLine={false} tick={<RenderSPO2YAxisTick />} />
                  <Line dataKey="spo2" stroke={greenColor} connectNulls={true} legendType="square" dot={this.renderSPO2Dot} />
                  {/* <Line dataKey="ambpm" stroke={blueColor} connectNulls={true} legendType="square"/>
                            <Line dataKey="pmbpm" stroke={redColor} connectNulls={true} legendType="square"/> */}
                {this.state.spo2HGoal ? <ReferenceLine y={this.state.spo2HGoal} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={this.state.spo2HGoal} position="insideLeft" content={this.renderLabelContent} />
                </ReferenceLine> : ""}
                {this.state.spo2LGoal ? <ReferenceLine y={this.state.spo2LGoal} stroke="#C23579" ifOverflow="extendDomain">
                    <Label value={this.state.spo2LGoal} position="insideLeft" content={this.renderLabelContent} />
                </ReferenceLine> : ""}
                </LineChart>
              </ResponsiveContainer>
              <p className="mobile-graph-down">
                7-Day Average: <b style={{ fontSize: "17px" }}>
                  {this.state.dataAverage.spo2}
                </b> ％ {spo2IconUrl ? <img src={spo2IconUrl} width={12} height="auto" /> : ""}
              </p>
            </div>
            <div style={{ height: "30px" }} />
          </div>;
    }
}



// WEBPACK FOOTER //
// ./src/components/graph/Graph.jsx